webpackJsonp([24],{

/***/ 1201:
/***/ (function(module, exports) {

function buildDistanceInWordsLocale () {
  var distanceInWordsLocale = {
    lessThanXSeconds: {
      one: 'menos de un segundo',
      other: 'menos de {{count}} segundos'
    },

    xSeconds: {
      one: '1 segundo',
      other: '{{count}} segundos'
    },

    halfAMinute: 'medio minuto',

    lessThanXMinutes: {
      one: 'menos de un minuto',
      other: 'menos de {{count}} minutos'
    },

    xMinutes: {
      one: '1 minuto',
      other: '{{count}} minutos'
    },

    aboutXHours: {
      one: 'alrededor de 1 hora',
      other: 'alrededor de {{count}} horas'
    },

    xHours: {
      one: '1 hora',
      other: '{{count}} horas'
    },

    xDays: {
      one: '1 día',
      other: '{{count}} días'
    },

    aboutXMonths: {
      one: 'alrededor de 1 mes',
      other: 'alrededor de {{count}} meses'
    },

    xMonths: {
      one: '1 mes',
      other: '{{count}} meses'
    },

    aboutXYears: {
      one: 'alrededor de 1 año',
      other: 'alrededor de {{count}} años'
    },

    xYears: {
      one: '1 año',
      other: '{{count}} años'
    },

    overXYears: {
      one: 'más de 1 año',
      other: 'más de {{count}} años'
    },

    almostXYears: {
      one: 'casi 1 año',
      other: 'casi {{count}} años'
    }
  }

  function localize (token, count, options) {
    options = options || {}

    var result
    if (typeof distanceInWordsLocale[token] === 'string') {
      result = distanceInWordsLocale[token]
    } else if (count === 1) {
      result = distanceInWordsLocale[token].one
    } else {
      result = distanceInWordsLocale[token].other.replace('{{count}}', count)
    }

    if (options.addSuffix) {
      if (options.comparison > 0) {
        return 'en ' + result
      } else {
        return 'hace ' + result
      }
    }

    return result
  }

  return {
    localize: localize
  }
}

module.exports = buildDistanceInWordsLocale


/***/ }),

/***/ 1202:
/***/ (function(module, exports, __webpack_require__) {

var buildFormattingTokensRegExp = __webpack_require__(294)

function buildFormatLocale () {
  var months3char = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic']
  var monthsFull = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre']
  var weekdays2char = ['do', 'lu', 'ma', 'mi', 'ju', 'vi', 'sa']
  var weekdays3char = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb']
  var weekdaysFull = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado']
  var meridiemUppercase = ['AM', 'PM']
  var meridiemLowercase = ['am', 'pm']
  var meridiemFull = ['a.m.', 'p.m.']

  var formatters = {
    // Month: Jan, Feb, ..., Dec
    'MMM': function (date) {
      return months3char[date.getMonth()]
    },

    // Month: January, February, ..., December
    'MMMM': function (date) {
      return monthsFull[date.getMonth()]
    },

    // Day of week: Su, Mo, ..., Sa
    'dd': function (date) {
      return weekdays2char[date.getDay()]
    },

    // Day of week: Sun, Mon, ..., Sat
    'ddd': function (date) {
      return weekdays3char[date.getDay()]
    },

    // Day of week: Sunday, Monday, ..., Saturday
    'dddd': function (date) {
      return weekdaysFull[date.getDay()]
    },

    // AM, PM
    'A': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemUppercase[1] : meridiemUppercase[0]
    },

    // am, pm
    'a': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemLowercase[1] : meridiemLowercase[0]
    },

    // a.m., p.m.
    'aa': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemFull[1] : meridiemFull[0]
    }
  }

  // Generate ordinal version of formatters: M -> Mo, D -> Do, etc.
  var ordinalFormatters = ['M', 'D', 'DDD', 'd', 'Q', 'W']
  ordinalFormatters.forEach(function (formatterToken) {
    formatters[formatterToken + 'o'] = function (date, formatters) {
      return ordinal(formatters[formatterToken](date))
    }
  })

  return {
    formatters: formatters,
    formattingTokensRegExp: buildFormattingTokensRegExp(formatters)
  }
}

function ordinal (number) {
  return number + 'º'
}

module.exports = buildFormatLocale


/***/ }),

/***/ 1203:
/***/ (function(module, exports, __webpack_require__) {

var buildDistanceInWordsLocale = __webpack_require__(1201)
var buildFormatLocale = __webpack_require__(1202)

/**
 * @category Locales
 * @summary Spanish locale.
 * @author Juan Angosto [@juanangosto]{@link https://github.com/juanangosto}
 * @author Guillermo Grau [@guigrpa]{@link https://github.com/guigrpa}
 * @author Fernando Agüero [@fjaguero]{@link https://github.com/fjaguero}
 */
module.exports = {
  distanceInWords: buildDistanceInWordsLocale(),
  format: buildFormatLocale()
}


/***/ }),

/***/ 1259:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_ButtonCreate__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_ButtonCreate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_shared_ButtonCreate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__ = __webpack_require__(879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_date_fns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_locale_es__ = __webpack_require__(1203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_date_fns_locale_es___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_date_fns_locale_es__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_helper__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_mixins__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_filters__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_shared_AmountsComponent__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_shared_AmountsComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_shared_AmountsComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__subComponents_GeneralAvailability__ = __webpack_require__(1545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__subComponents_GeneralAvailability___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__subComponents_GeneralAvailability__);







var loadAvailability = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
		var params;
		return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						params = {
							dateStart: this.dateStart,
							idSubsidiary: this.subsidiary,
							dateEnd: this.dateEnd,
							roomTypeIdSelect: this.roomTypeSelected
						};
						_context.prev = 1;
						_context.next = 4;
						return this.$http.patch('//pms.controlinn.com/api' + '/subsidiary/availability', __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, params));

					case 4:
						this.loadData();
						this.showNotification('Se realizo con exito la actualizaciòn');
						_context.next = 11;
						break;

					case 8:
						_context.prev = 8;
						_context.t0 = _context['catch'](1);

						if (_context.t0.status === 405) {
							this.showNotification('Error al Actualizar');
						}

					case 11:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[1, 8]]);
	}));

	return function loadAvailability() {
		return _ref.apply(this, arguments);
	};
}();

var assignBooking = function () {
	var _ref2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
		var model, query, isToday, allDays, message;
		return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						model = {
							codeBooking: this.bookingCode,
							idRoom: this.roomList.id
						};
						_context2.prev = 1;
						_context2.next = 4;
						return this.$http.post('//pms.controlinn.com/api' + '/booking/asignedroom', model);

					case 4:
						this.showNotification('La habitación se asignó correctamente.', 'success');
						this.bookingSelected = null;
						query = {
							initDate: this.dateStart,
							endDate: this.dateEnd,
							roomId: this.roomList.id,
							bookingCode: this.bookingCode
						};
						isToday = false;
						allDays = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["eachDay"])(this.dateStart, this.dateEnd);

						allDays.forEach(function (d) {
							if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["differenceInDays"])(new Date(), d) === 0 && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["differenceInDays"])(new Date(), d) !== -0) {
								isToday = true;
							}
						});
						if (isToday) {
							this.goToCheckIn(this.subsidiary, this.roomTypeSelected, query);
						} else {
							this.$router.push({ name: 'cms-calendar', params: { bookingCode: null } });
						}
						_context2.next = 17;
						break;

					case 13:
						_context2.prev = 13;
						_context2.t0 = _context2['catch'](1);
						message = _context2.t0.data.message;

						if (_context2.t0.status === 405) {
							if (message === 'BOOKING_NOT_AVAILABLE_RANGE') {
								this.showNotification('La habitación ya cuenta con una reserva dentro de las fechas seleccionadas.', 'error');
							}
						}

					case 17:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this, [[1, 13]]);
	}));

	return function assignBooking() {
		return _ref2.apply(this, arguments);
	};
}();

var cancelBooking = function () {
	var _ref4 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
		var codeBooking;
		return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						codeBooking = this.customerInfo.customer.bookingCode;
						_context3.next = 3;
						return this.$http.put('//pms.controlinn.com/api' + '/reserve/' + codeBooking, this.cancelModel);

					case 3:
						this.showNotification('La reserva ha sido anulada correctamente.', 'success');
						this.loadData();
						this.closeBookingModal('Cancel');

					case 6:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this);
	}));

	return function cancelBooking() {
		return _ref4.apply(this, arguments);
	};
}();

var downloadCardTravel = function () {
	var _ref5 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
		var baseUrl, code, typeDocumentCode, name, responseType, cardModel, response, blob;
		return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
			while (1) {
				switch (_context4.prev = _context4.next) {
					case 0:
						baseUrl = '//pms.controlinn.com/api';
						code = this.customerInfo.customer.bookingCode;
						typeDocumentCode = 'registerCard';
						name = 'TARJETA-DE-EMBARQUE' + code;
						responseType = 'blob';
						cardModel = { details: [{}] };
						_context4.next = 8;
						return this.$http.post(baseUrl + '/booking/' + code + '/report/' + typeDocumentCode, cardModel, { responseType: responseType });

					case 8:
						response = _context4.sent;
						blob = helperMethods.generateBlob(response.bodyBlob);

						helperMethods.showDownloadDialog(blob, name, 'pdf');

					case 11:
					case 'end':
						return _context4.stop();
				}
			}
		}, _callee4, this);
	}));

	return function downloadCardTravel() {
		return _ref5.apply(this, arguments);
	};
}();

var dropEvent = function () {
	var _ref6 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5(room, day, event) {
		var model, message;
		return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
			while (1) {
				switch (_context5.prev = _context5.next) {
					case 0:
						if (!this.customerSelected) {
							_context5.next = 17;
							break;
						}

						model = {
							codeBooking: this.customerSelected.bookingCode,
							idRoom: room.id,
							checkIn: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["format"])(new Date(day.date), 'YYYY-MM-DD'),
							checkOut: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["format"])(new Date(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["addDays"])(day.date, this.customerSelected.dates - 1)), 'YYYY-MM-DD')
						};
						_context5.prev = 2;
						_context5.next = 5;
						return this.$http.put('//pms.controlinn.com/api' + '/booking/asignedroom', model);

					case 5:
						this.showNotification('La reserva se modificó correctamente.', 'success');
						_context5.next = 12;
						break;

					case 8:
						_context5.prev = 8;
						_context5.t0 = _context5['catch'](2);
						message = _context5.t0.data.message;

						if (_context5.t0.status !== 500) {
							if (message === 'BOOKING_NOT_AVAILABLE_RANGE') {
								this.showNotification('La habitación ya cuenta con una reserva dentro de las fechas seleccionadas.', 'error');
							}
							if (message === 'BOOKING_CANT_UPDATE_CURRENT_ONE') {
								this.showNotification('La reserva no se puede mover a fechas anteriores.', 'error');
							}
						}

					case 12:
						_context5.prev = 12;

						this.loadData();
						return _context5.finish(12);

					case 15:
						_context5.next = 20;
						break;

					case 17:
						event.preventDefault();
						this.loadData();
						this.showNotification('No ha seleccionado ninguna reserva.', 'error');

					case 20:
						this.customerSelected = {};
						this.roomSelected = {};
						this.daySelected = {};

					case 23:
					case 'end':
						return _context5.stop();
				}
			}
		}, _callee5, this, [[2, 8, 12, 15]]);
	}));

	return function dropEvent(_x, _x2, _x3) {
		return _ref6.apply(this, arguments);
	};
}();

var loadBooking = function () {
	var _ref7 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6(code) {
		var response;
		return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
			while (1) {
				switch (_context6.prev = _context6.next) {
					case 0:
						if (!code) {
							_context6.next = 8;
							break;
						}

						_context6.next = 3;
						return this.$http.get('//pms.controlinn.com/api' + '/bookings/' + code + '/by-code');

					case 3:
						response = _context6.sent;

						this.bookingSelected = response.data.data[0];
						if (this.bookingSelected) {
							this.dateStart = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["format"])(this.bookingSelected.date_start, 'YYYY-MM-DD');
							this.dateEnd = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["format"])(this.bookingSelected.date_end, 'YYYY-MM-DD');
							this.subsidiary = this.bookingSelected.summary.personalInformation.hotelId;
							this.showDates();
							this.footer = [];
							this.freeRooms = [];
							this.rooms = [];
							this.roomsTaken = [];
							this.roomTypes = [];
						}
						_context6.next = 11;
						break;

					case 8:
						this.setYearSelected();
						this.loadParams();
						this.loadData(this.roomTypeSelected);

					case 11:
					case 'end':
						return _context6.stop();
				}
			}
		}, _callee6, this);
	}));

	return function loadBooking(_x5) {
		return _ref7.apply(this, arguments);
	};
}();

var loadData = function () {
	var _ref8 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee7(id) {
		var _this3 = this;

		var idRoomType, params, _ref9, calendar;

		return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
			while (1) {
				switch (_context7.prev = _context7.next) {
					case 0:
						this.onChangeRoomType();
						idRoomType = id || this.roomTypeSelected;
						params = 'dateStart=' + this.dateStart + '&dateEnd=' + this.dateEnd + '&typeRoom=' + idRoomType + '&idHotel=' + this.subsidiary;
						_context7.next = 5;
						return this.$http.get('//pms.controlinn.com/api' + '/booking/calendar?' + params);

					case 5:
						_ref9 = _context7.sent;
						calendar = _ref9.data;

						this.rooms = calendar.body.map(function (room) {
							var newRoom = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, room);
							newRoom.isSelected = false;
							newRoom.days = _this3.monthSelected.days.map(function (d) {
								var newD = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, d);
								newD.isTaken = false;
								room.customers.forEach(function (c) {
									var allDays = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["eachDay"])(c.dateRange[0], c.dateRange[1]);
									var allDaysOnInitMonth = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(allDays));
									allDaysOnInitMonth.forEach(function (dm) {
										if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["isSameDay"])(dm, d.date)) {
											newD.isTaken = true;
										}
									});
								});
								return newD;
							});
							if (newRoom.customers.length > 0) {
								newRoom.customers = room.customers.map(function (customer) {
									var newCustomer = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, customer);
									newCustomer.initDay = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["getDate"])(customer.dateRange[0]);
									newCustomer.initMonth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["getMonth"])(customer.dateRange[0]) + 1;
									newCustomer.initYear = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["getYear"])(customer.dateRange[0]);
									newCustomer.endDay = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["getDate"])(customer.dateRange[1]);
									newCustomer.endMonth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["getMonth"])(customer.dateRange[1]) + 1;
									newCustomer.endYear = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["getYear"])(customer.dateRange[1]);
									var allDays = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["eachDay"])(customer.dateRange[0], customer.dateRange[1]);
									newCustomer.dates = allDays.length;
									var allDaysOnInitMonth = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(allDays));
									newCustomer.allDaysOnInitMonth = allDaysOnInitMonth.map(function (ad) {
										var newAd = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, ad);
										newAd.day = {
											date: ad,
											day: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["getDate"])(ad),
											value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["getDay"])(ad),
											isWeekend: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["isWeekend"])(ad),
											shortDay: _this3.shortDays[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["getDay"])(ad)],
											month: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["getMonth"])(ad) + 1,
											isSelected: false,
											year: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["getYear"])(ad)
										};
										return newAd.day;
									});
									newCustomer.datesOnInitMonth = allDaysOnInitMonth.length;
									if (allDays.length > allDaysOnInitMonth.length) {
										newCustomer.datesOnInitMonth = allDaysOnInitMonth.length - 1;
									}
									return newCustomer;
								});
							} else {
								var customer = {
									bookingCode: null,
									color: '#ffffff',
									country: '' + 172,
									dateRange: ['', ''],
									lastname: null,
									name: null
								};
								var allDaysOnInitMonth = [];
								var allDays = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["eachDay"])(customer.dateRange[0], customer.dateRange[1]);
								allDays.forEach(function (allDay) {
									if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["getYear"])(allDay) === __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["getYear"])(customer.dateRange[0]) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["getMonth"])(allDay) + 1 === __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["getMonth"])(customer.dateRange[0]) + 1) {
										allDaysOnInitMonth.push(allDay);
									}
									if (_this3.monthSelected.endMonth > _this3.monthSelected.id && _this3.monthSelected.endMonth === __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["getMonth"])(customer.dateRange[1]) + 1) {
										if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["getYear"])(allDay) === __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["getYear"])(customer.dateRange[1]) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["getMonth"])(allDay) + 1 === __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["getMonth"])(customer.dateRange[1]) + 1) {
											allDaysOnInitMonth.push(allDay);
										}
									}
								});
								allDaysOnInitMonth = allDaysOnInitMonth.map(function (ad) {
									var newAd = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, ad);
									newAd.day = {
										date: ad,
										day: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["getDate"])(ad),
										value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["getDay"])(ad),
										isWeekend: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["isWeekend"])(ad),
										shortDay: _this3.shortDays[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["getDay"])(ad)],
										month: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["getMonth"])(ad) + 1,
										isSelected: false,
										year: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["getYear"])(ad)
									};
									return newAd.day;
								});
								var nullCustomer = {
									initDay: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["getDate"])(customer.dateRange[0]),
									initMonth: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["getMonth"])(customer.dateRange[0]) + 1,
									initYear: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["getYear"])(customer.dateRange[0]),
									endDay: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["getDate"])(customer.dateRange[1]),
									endMonth: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["getMonth"])(customer.dateRange[1]) + 1,
									endYear: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["getYear"])(customer.dateRange[1]),
									dates: allDays.length,
									datesOnInitMonth: allDaysOnInitMonth.length,
									allDaysOnInitMonth: allDaysOnInitMonth
								};
								if (allDays.length > allDaysOnInitMonth.length) {
									nullCustomer.datesOnInitMonth = allDaysOnInitMonth.length - 1;
								}
								newRoom.customers.push(nullCustomer);
							}
							return newRoom;
						});
						this.footer = calendar.footer;
						this.roomsTaken = calendar.footer.map(function (taken) {
							var newTaken = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, taken);
							var percent = Number(taken.percent);
							newTaken.percent = percent % 1 === 0 ? percent : percent.toFixed(2);
							delete newTaken.currency;
							delete newTaken.free;
							delete newTaken.occupied;
							delete newTaken.price;
							delete newTaken.total;
							return newTaken;
						});
						this.freeRooms = calendar.footer.map(function (free) {
							var newFree = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, free);
							delete newFree.occupied;
							delete newFree.percent;
							delete newFree.total;
							return newFree;
						});
						if (this.rooms.length === 0 && this.footer.length === 0) {
							this.showNotification('No se encontró data para esta búsqueda.', 'info');
						}

					case 12:
					case 'end':
						return _context7.stop();
				}
			}
		}, _callee7, this);
	}));

	return function loadData(_x6) {
		return _ref8.apply(this, arguments);
	};
}();

var loadParams = function () {
	var _ref10 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee8() {
		var _ref11, subsidiaries;

		return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
			while (1) {
				switch (_context8.prev = _context8.next) {
					case 0:
						_context8.next = 2;
						return this.$http.get('//pms.controlinn.com/api' + '/hotel');

					case 2:
						_ref11 = _context8.sent;
						subsidiaries = _ref11.data;

						this.subsidiaries = subsidiaries.data || [];
						if (subsidiaries.data[0]) {
							this.subsidiary = subsidiaries.data[0].id;
						} else {
							this.subsidiary = this.bookingSelected ? this.bookingSelected.summary.personalInformation.hotelId : 0;
						}

					case 6:
					case 'end':
						return _context8.stop();
				}
			}
		}, _callee8, this);
	}));

	return function loadParams() {
		return _ref10.apply(this, arguments);
	};
}();

var loadRoomsList = function () {
	var _ref12 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee9() {
		var baseUrl, subsidiaryId, roomTypeId, params, response;
		return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
			while (1) {
				switch (_context9.prev = _context9.next) {
					case 0:
						baseUrl = '//pms.controlinn.com/api';
						subsidiaryId = this.subsidiary;
						roomTypeId = this.roomTypeSelected;
						params = {
							dateInit: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["format"])(this.bookingSelected.date_start, 'YYYY-MM-DD'),
							dateEnd: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["format"])(this.bookingSelected.date_end, 'YYYY-MM-DD')
						};
						_context9.next = 6;
						return this.$http.get(baseUrl + '/roomtype/' + subsidiaryId + '/rooms/' + roomTypeId, { params: params });

					case 6:
						response = _context9.sent;

						this.roomsList = response.data.data;
						this.showNotification('Debe seleccionar y asignar un número de habitación a la reserva.', 'info');

					case 9:
					case 'end':
						return _context9.stop();
				}
			}
		}, _callee9, this);
	}));

	return function loadRoomsList() {
		return _ref12.apply(this, arguments);
	};
}();

var loadTypeRooms = function () {
	var _ref13 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee10() {
		var response;
		return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
			while (1) {
				switch (_context10.prev = _context10.next) {
					case 0:
						_context10.next = 2;
						return this.$http.get('//pms.controlinn.com/api' + '/roomtype/' + this.subsidiary);

					case 2:
						response = _context10.sent;

						this.roomTypes = response.data.data;
						if (this.bookingSelected) {
							this.roomTypeSelected = this.bookingSelected.entity_id;
							this.loadRoomsList();
						} else {
							this.roomTypeSelected = response.data.data[0] ? response.data.data[0].id : 1;
							this.loadData();
						}

					case 5:
					case 'end':
						return _context10.stop();
				}
			}
		}, _callee10, this);
	}));

	return function loadTypeRooms() {
		return _ref13.apply(this, arguments);
	};
}();

var noShowBooking = function () {
	var _ref14 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee11() {
		return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
			while (1) {
				switch (_context11.prev = _context11.next) {
					case 0:
						_context11.next = 2;
						return this.$http.put('//pms.controlinn.com/api' + '/booking/no-show', this.noShowModel);

					case 2:
						this.showNotification('La reserva ha sido liberada por no-show.', 'success');
						this.closeBookingModal('NoShow');
						this.loadData(this.roomTypeSelected);

					case 5:
					case 'end':
						return _context11.stop();
				}
			}
		}, _callee11, this);
	}));

	return function noShowBooking() {
		return _ref14.apply(this, arguments);
	};
}();

var seeBooking = function () {
	var _ref15 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee12() {
		var codeBooking, _ref16, booking, bookingData, channel, questions;

		return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
			while (1) {
				switch (_context12.prev = _context12.next) {
					case 0:
						codeBooking = this.customerInfo.customer.bookingCode;
						_context12.next = 3;
						return this.$http.get('//pms.controlinn.com/api' + '/bookings/' + codeBooking);

					case 3:
						_ref16 = _context12.sent;
						booking = _ref16.data;
						bookingData = booking.data.summary.booking;

						booking.data.quantity = Number(bookingData.adults) + Number(bookingData.childrens);
						booking.data.customer.data.documentName = booking.data.customer.data.documentType === 1 ? 'DNI' : 'RUC';
						if (booking.data.customerAditional && booking.data.customerAditional.length > 0) {
							booking.data.customerAditional = booking.data.customerAditional.map(function (cusAdd) {
								var newCusAdd = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, cusAdd);
								if (cusAdd.documentType === 1) {
									newCusAdd.documentName = 'DNI';
								} else if (cusAdd.documentType === 2) {
									newCusAdd.documentName = 'Pasaporte';
								} else if (cusAdd.documentType === 3) {
									newCusAdd.documentName = 'Carnet de Extranjería';
								} else {
									newCusAdd.documentName = 'RUC';
								}
								return newCusAdd;
							});
						}
						channel = booking.data.channel ? booking.data.channel.data : { inputInformations: [] };

						if (channel.inputInformations.length > 0) {
							questions = channel.questions || {};

							channel.inputInformations.forEach(function (input) {
								var keySelected = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(questions).find(function (key) {
									return key === input.value;
								});
								questions[input.label] = questions[keySelected];
							});
							booking.data.channel.data.questions = questions;
						}
						this.seeModel = booking.data;
						this.modalSeeBooking = true;

					case 13:
					case 'end':
						return _context12.stop();
				}
			}
		}, _callee12, this);
	}));

	return function seeBooking() {
		return _ref15.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











var helperMethods = __WEBPACK_IMPORTED_MODULE_10__shared_helper__["a" /* default */].methods;

function mounted() {
	this.setYearSelected();
	if (this.bookingCode && this.bookingCode !== undefined && this.bookingCode !== null) {
		this.loadBooking(this.bookingCode);
	}
	this.loadParams();
	this.fixedBarDateCalculations();
}

function fixedBarDateCalculations() {
	var _this = this;

	var mainEl = this.$refs['base-calendar'];
	var el = this.$refs['movil-date'];
	var initialPositionY = el.getBoundingClientRect().y;
	var initialPositionX = el.getBoundingClientRect().x;
	var colWidth = this.$refs.col.offsetWidth;
	var barFixed = this.$refs['bar-fixed'];
	var innerContainer = this.$refs['col-calendar-31'];
	var gap = initialPositionX - colWidth;
	mainEl.addEventListener('scroll', function () {
		var _el$getBoundingClient = el.getBoundingClientRect(),
		    x = _el$getBoundingClient.x,
		    y = _el$getBoundingClient.y;

		barFixed.style.transform = 'translateX(' + (x - gap) + 'px)';
		_this.showDateBarFixed = initialPositionY > y + 15;
	});
	innerContainer.addEventListener('scroll', function () {
		var _el$getBoundingClient2 = el.getBoundingClientRect(),
		    x = _el$getBoundingClient2.x;

		barFixed.style.transform = 'translateX(' + (x - gap) + 'px)';
	});
}

function arrowIcon() {
	var arrow = this.onChangeDate ? 'arrow_drop_up' : 'arrow_drop_down';
	return arrow;
}

function arrowIconEnd() {
	var arrow = this.onChangeEnd ? 'arrow_drop_up' : 'arrow_drop_down';
	return arrow;
}

function arrowIconStart() {
	var arrow = this.onChange ? 'arrow_drop_up' : 'arrow_drop_down';
	return arrow;
}

function bookingCode(code) {
	return this.loadBooking(code);
}

function calculateLength(dayIndex, _ref3, day) {
	var allDaysOnInitMonth = _ref3.allDaysOnInitMonth,
	    dates = _ref3.dates,
	    initDay = _ref3.initDay;

	var showInDay = false;
	var newDay = day;
	for (var index = 0; index < dates; index += 1) {
		if (initDay + (index + 1) === day) {
			showInDay = true;
			newDay = day;
		}
	}
	var length = dayIndex === 0 && showInDay ? allDaysOnInitMonth.length - (newDay - initDay) : allDaysOnInitMonth.length;
	return length;
}

function changeEndIcon(result) {
	this.onChangeEnd = result;
}

function changeFormatDate(value) {
	return new Date(value).toISOString().substr(0, 10);
}

function changeIcon(result) {
	this.onChange = result;
}

function changeIconDate(result) {
	this.onChangeDate = result;
}

function closeBookingModal(type) {
	this['modal' + type + 'Booking'] = false;
	if (type === 'Cancel') {
		this.cancelModel = {
			description: '',
			title: ''
		};
	}
	if (type === 'NoShow') {
		this.noShowModel = {
			codeBooking: '',
			date: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["format"])(new Date(), 'YYYY-MM-DD'),
			flagBilling: false
		};
	}
}

function closeMenuBooking() {
	this.menuBooking = false;
	this.customerInfo = {
		customer: { id: null, dateRange: [], allDaysOnInitMonth: [] }
	};
}

function closeMenuNew() {
	this.menuNewBooking = false;
	this.newRanges = [];
}

function daysByMonth() {
	var _this2 = this;

	var days = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["eachDay"])(this.dateStart, this.dateEnd);
	var daysComplete = days.map(function (day, index) {
		var newDay = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, day);
		newDay.id = index + 1;
		newDay.date = day;
		newDay.day = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["getDate"])(day);
		newDay.value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["getDay"])(day);
		newDay.isWeekend = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["isWeekend"])(day);
		newDay.shortDay = _this2.shortDays[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["getDay"])(day)];
		newDay.month = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["getMonth"])(day) + 1;
		newDay.menuNew = false;
		if (index + 1 === days.length) {
			_this2.monthSelected.endMonth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["getMonth"])(day) + 1;
		}
		return newDay;
	});
	return daysComplete;
}

function dragEvent(room, day) {
	this.roomSelected = room;
	this.daySelected = day;
	var customerInRooms = this.rooms.map(function (r) {
		var newR = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, r);
		if (r.id === room.id) {
			newR.customer = r.customers.find(function (c) {
				return c.allDaysOnInitMonth.findIndex(function (ca) {
					return ca.day === day.day && ca.month === day.month;
				}) > -1;
			});
		}
		return newR.customer;
	});
	this.customerSelected = customerInRooms.find(function (cir) {
		return cir !== undefined;
	});
}

function expiredReservation() {
	return this.customerInfo.customer.allDaysOnInitMonth.every(function (d) {
		return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["differenceInDays"])(d.date, new Date()) < 0;
	});
}

function goToBilling(hotelId, roomTypeId) {
	var code = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'billing';

	var query = {
		initDate: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["format"])(this.customerInfo.customer.dateRange[0], 'YYYY-MM-DD'),
		endDate: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["format"])(this.customerInfo.customer.dateRange[1], 'YYYY-MM-DD'),
		roomId: this.customerInfo.room.id,
		bookingCode: this.customerInfo.customer.bookingCode,
		active: 'tab-6',
		code: code
	};
	this.$router.push({
		name: 'checkin-form-tabs',
		params: {
			hotelId: hotelId,
			roomTypeId: roomTypeId
		},
		query: query
	});
}

function goToCheckIn(hotelId, roomTypeId) {
	var query = {
		initDate: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["format"])(this.customerInfo.customer.dateRange[0], 'YYYY-MM-DD'),
		endDate: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["format"])(this.customerInfo.customer.dateRange[1], 'YYYY-MM-DD'),
		roomId: this.customerInfo.room.id,
		bookingCode: this.customerInfo.customer.bookingCode
	};
	this.$router.push({
		name: 'checkin-form-tabs',
		params: {
			hotelId: hotelId,
			roomTypeId: roomTypeId
		},
		query: query
	});
}

function goToCheckOut(hotelId, roomTypeId) {
	var isToday = false;
	var allDays = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["eachDay"])(this.customerInfo.customer.dateRange[0], this.customerInfo.customer.dateRange[1]);
	allDays.forEach(function (d) {
		if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["differenceInDays"])(new Date(), d) === 0) {
			isToday = true;
		}
	});
	if (isToday) {
		var query = {
			initDate: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["format"])(this.customerInfo.customer.dateRange[0], 'YYYY-MM-DD'),
			endDate: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["format"])(this.customerInfo.customer.dateRange[1], 'YYYY-MM-DD'),
			roomId: this.customerInfo.room.id,
			bookingCode: this.customerInfo.customer.bookingCode,
			active: 'tab-2'
		};
		this.$router.push({
			name: 'checkin-form-tabs',
			params: {
				hotelId: hotelId,
				roomTypeId: roomTypeId
			},
			query: query
		});
	} else {
		this.showNotification('No es posible realizar el check out en reservas de días anteriores o futuros a la fecha actual.', 'error');
	}
}

function goToPrepayment(booking) {
	this.$router.push({
		name: 'prepayment',
		params: {
			bookingCode: booking.customer.bookingCode
		}
	});
}

function goToReserve() {
	var isToday = false;
	var allDays = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["eachDay"])(this.newRanges[0].day.date, this.newRanges[1].day.date);
	allDays.forEach(function (d) {
		if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["differenceInDays"])(new Date(), d) <= 0) {
			isToday = true;
		}
	});
	if (isToday) {
		this.$router.push({
			name: 'booking-new',
			query: this.checkInQuery
		});
	} else {
		this.showNotification('No se pueden crear reservas en fechas anteriores a la actual. Modifica tu selección.', 'error');
	}
}

function goToUpdateBooking() {
	this.$router.push({
		name: 'booking-edit',
		params: {
			codeBooking: this.seeModel.code
		}
	});
}

function hideCustomerInfo() {
	this.customerInfo = { customer: { id: 0 } };
}

function isAfterMethod(date, dateToCompare) {
	return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["differenceInDays"])(date, dateToCompare) > 0;
}

function isNoShow() {
	var diff = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["differenceInHours"])(this.customerInfo.customer.dateRange[0], new Date()) < 0;
	var afterDay = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["isAfter"])(this.customerInfo.customer.dateRange[1], new Date());
	return diff && afterDay;
}

function methodIsAfter(firstDate, secondDate) {
	return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["isAfter"])(firstDate, secondDate);
}

function methodIsSameDay(firstDate, secondDate) {
	return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["isSameDay"])(firstDate, secondDate);
}

function monthActive(id, noLoadData) {
	var _this4 = this;

	if (id > 0) {
		var month = {};
		this.pickMonths = true;
		this.months.forEach(function (item) {
			if (_this4.monthId === 0) {
				_this4.monthId = 1;
			}
			if (item.id === _this4.monthId) {
				month = item;
			}
		});
		var newMonth = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, month);
		this.dateEnd = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["format"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["addMonths"])(new Date(), 1), 'YYYY-MM-DD');
		this.dateStart = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["format"])(new Date(), 'YYYY-MM-DD');
		this.$nextTick(function () {
			newMonth.days = _this4.daysByMonth();
		});
		this.monthSelected = newMonth;
		if (!noLoadData) {
			if (this.bookingSelected) {
				this.bookingSelected = null;
				var year = new Date().getFullYear();
				this.setYearSelected(year);
				this.$router.push({ name: 'calendar' });
			}
			this.loadData();
		}
	}
}

function newBooking(e, day, room) {
	var _this5 = this;

	if (this.newRanges.length === 1) {
		if (this.newRanges[0].room.id === room.id && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["isSameDay"])(this.newRanges[0].day.date, day.date) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["isAfter"])(day.date, this.newRanges[0].day.date)) {
			var newBookingDisabled = false;
			if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["isAfter"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["subDays"])(day.date, 1), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["addDays"])(this.newRanges[0].day.date, 1)) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["isSameDay"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["subDays"])(day.date, 1), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["addDays"])(this.newRanges[0].day.date, 1))) {
				var newBookingAllDays = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["isSameDay"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["subDays"])(day.date, 1), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["addDays"])(this.newRanges[0].day.date, 1)) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["addDays"])(this.newRanges[0].day.date, 1) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["eachDay"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["addDays"])(this.newRanges[0].day.date, 1), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["subDays"])(day.date, 1));
				room.customers.forEach(function (roomCustomer) {
					if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["isSameDay"])(_this5.newRanges[0].day.date, roomCustomer.allDaysOnInitMonth[0]) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["isSameDay"])(day.date, roomCustomer.allDaysOnInitMonth[1])) {
						newBookingDisabled = true;
					} else {
						roomCustomer.allDaysOnInitMonth.forEach(function (roomDay) {
							if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["isDate"])(newBookingAllDays)) {
								if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["isSameDay"])(newBookingAllDays, roomDay.date)) {
									newBookingDisabled = true;
								}
							} else if (newBookingAllDays.findIndex(function (newBookingDay) {
								return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["isSameDay"])(newBookingDay, roomDay.date);
							}) > -1) {
								newBookingDisabled = true;
							}
						});
					}
				});
			}
			if (!newBookingDisabled) {
				var initDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["format"])(this.newRanges[0].day.date, 'YYYY-MM-DD');
				var endDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["format"])(day.date, 'YYYY-MM-DD');
				this.newRanges.push({ day: day, room: room });
				this.monthSelected.days = this.monthSelected.days.map(function (daySelected) {
					var newDaySelected = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, daySelected);
					newDaySelected.menu = false;
					if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["isSameDay"])(daySelected.date, day.date)) {
						newDaySelected.isSelected = true;
						newDaySelected.menu = true;
					}
					return newDaySelected;
				});
				this.checkInQuery = {
					initDate: initDate,
					endDate: endDate,
					hotelId: this.subsidiary,
					roomTypeId: this.roomTypeSelected,
					roomId: this.newRanges[0].room.id
				};
				this.menuBooking = false;
				e.preventDefault();
				this.menuNewBooking = true;
				this.xNewBooking = e.clientX;
				this.yNewBooking = e.clientY;
			} else {
				this.newRanges = [];
				this.newRanges.push({ day: day, room: room });
				this.monthSelected.days = this.monthSelected.days.map(function (daySelected) {
					var newDaySelected = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, daySelected);
					newDaySelected.isSelected = false;
					newDaySelected.menu = false;
					if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["isSameDay"])(daySelected.date, day.date)) {
						newDaySelected.isSelected = true;
						newDaySelected.menu = true;
					}
					return newDaySelected;
				});
				this.rooms = this.rooms.map(function (roomSelected) {
					var newRoomSelected = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, roomSelected);
					newRoomSelected.isSelected = false;
					if (roomSelected.id === room.id) {
						newRoomSelected.isSelected = true;
					}
					return newRoomSelected;
				});
				this.checkInQuery = null;
				this.menuNewBooking = false;
			}
		} else {
			this.newRanges = [];
			this.newRanges.push({ day: day, room: room });
			this.monthSelected.days = this.monthSelected.days.map(function (daySelected) {
				var newDaySelected = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, daySelected);
				newDaySelected.isSelected = false;
				newDaySelected.menu = false;
				if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["isSameDay"])(daySelected.date, day.date)) {
					newDaySelected.isSelected = true;
					newDaySelected.menu = true;
				}
				return newDaySelected;
			});
			this.rooms = this.rooms.map(function (roomSelected) {
				var newRoomSelected = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, roomSelected);
				newRoomSelected.isSelected = false;
				if (roomSelected.id === room.id) {
					newRoomSelected.isSelected = true;
				}
				return newRoomSelected;
			});
			this.checkInQuery = null;
			this.menuNewBooking = false;
		}
	} else {
		this.newRanges = [];
		this.newRanges.push({ day: day, room: room });
		this.monthSelected.days = this.monthSelected.days.map(function (daySelected) {
			var newDaySelected = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, daySelected);
			newDaySelected.isSelected = false;
			newDaySelected.menu = false;
			if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["isSameDay"])(daySelected.date, day.date)) {
				newDaySelected.isSelected = true;
			}
			return newDaySelected;
		});
		this.rooms = this.rooms.map(function (roomSelected) {
			var newRoomSelected = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, roomSelected);
			newRoomSelected.isSelected = false;
			if (roomSelected.id === room.id) {
				newRoomSelected.isSelected = true;
			}
			return newRoomSelected;
		});
		this.checkInQuery = null;
		this.menuNewBooking = false;
		this.menuBooking = false;
	}
}

function onChangeRoomType() {
	if (this.bookingSelected) {
		this.bookingSelected = null;
		this.$router.push({ name: 'calendar' });
	}
}

function onChangeSubsidiary() {
	if (this.bookingSelected) {
		this.bookingSelected = null;
		this.$router.push({ name: 'calendar' });
		this.loadData();
	}
}

function openCancelBooking() {
	this.monthSelected.days = this.monthSelected.days.map(function (d) {
		var newD = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, d);
		newD.menu = false;
		return newD;
	});
	this.modalCancelBooking = true;
}

function openNoShowBooking() {
	this.noShowModel.codeBooking = this.customerInfo.customer.bookingCode;
	this.modalNoShowBooking = true;
}

function pickRanges() {
	this.pickMonths = false;
	this.monthId = 0;
	this.yearSelected = 0;
	this.yearRange = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["getYear"])(this.dateStart);
}

function setYearSelected(year) {
	var id = this.monthId || new Date().getMonth() + 1;
	this.pickMonths = true;
	this.dateStart = null;
	this.dateEnd = null;
	this.yearSelected = year || this.yearSelected;
	this.monthActive(id, true);
}

function showCustomerInfo(e, room, customer, day) {
	var _this6 = this;

	this.menuBooking = false;
	this.menuNewBooking = false;
	var changeZIndex = true;
	var exonerated = customer.flagTaxes ? 'Sí' : 'No';
	this.customerInfo = { room: room, customer: customer, day: day, changeZIndex: changeZIndex, exonerated: exonerated };
	this.rooms = this.rooms.map(function (roomS) {
		var newRoom = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, roomS);
		newRoom.isSelected = false;
		return newRoom;
	});
	this.monthSelected.days = this.monthSelected.days.map(function (dayS) {
		var newDay = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, dayS);
		newDay.isSelected = false;
		return newDay;
	});
	this.$nextTick(function () {
		e.preventDefault();
		_this6.xBooking = e.clientX;
		_this6.yBooking = e.clientY;
		_this6.menuBooking = true;
	});
}

function showDates() {
	var _this7 = this;

	var days = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["eachDay"])(this.dateStart, this.dateEnd);
	this.pickMonths = false;
	this.yearSelected = 0;
	this.monthId = 0;
	this.yearRange = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["getYear"])(this.dateStart);
	this.monthSelected = {};
	this.monthSelected.days = days.map(function (day, index) {
		var newDay = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, day);
		newDay.id = index + 1;
		newDay.date = day;
		newDay.day = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["getDate"])(day);
		newDay.month = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["getMonth"])(day) + 1;
		newDay.value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["getDay"])(day);
		newDay.isWeekend = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["isWeekend"])(day);
		newDay.shortDay = _this7.shortDays[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["getDay"])(day)];
		newDay.isSelected = false;
		if (index === 0) {
			_this7.monthSelected.id = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["getMonth"])(day) + 1;
		}
		if (index + 1 === days.length) {
			_this7.monthSelected.endMonth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["getMonth"])(day) + 1;
		}
		return newDay;
	});
	if (!this.bookingCode) {
		this.loadData();
	}
}

function showName(dayIndex, _ref17, day) {
	var initDay = _ref17.initDay,
	    dates = _ref17.dates;

	var showInDay = false;
	for (var index = 0; index < dates; index += 1) {
		if (initDay + (index + 1) === day) {
			showInDay = true;
		}
	}
	var showInOtherTag = dayIndex === 0 && showInDay;
	return showInOtherTag;
}

function toggleIconStartDate() {
	this.onChange = !this.startDate;
}

function toggleIconEndDate() {
	this.onChange = !this.endDate;
}

function goToDetailGuest(hotelId, roomTypeId) {
	var code = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'billing';

	var query = {
		initDate: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["format"])(this.customerInfo.customer.dateRange[0], 'YYYY-MM-DD'),
		endDate: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["format"])(this.customerInfo.customer.dateRange[1], 'YYYY-MM-DD'),
		roomId: this.customerInfo.room.id,
		bookingCode: this.customerInfo.customer.bookingCode,
		active: 'tab-1',
		code: code
	};
	var route = this.$router.resolve({
		name: 'checkin-form-tabs',
		params: {
			hotelId: hotelId,
			roomTypeId: roomTypeId
		},
		query: query
	});
	window.open(route.href, '_blank');
}

function validations() {
	return {
		cancelModel: {
			description: {
				required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"]
			},
			title: {
				required: __WEBPACK_IMPORTED_MODULE_7_vuelidate_lib_validators__["required"]
			}
		}
	};
}

function validationTakenDay(customer, day) {
	var flag = (Number(customer.initYear) === this.yearSelected || Number(customer.initYear) === this.yearRange) && (customer.initMonth === day.month || customer.endMonth === day.month) && customer.allDaysOnInitMonth.findIndex(function (ad) {
		return ad.day === day.day && ad.month === day.month;
	}) > -1;
	return flag;
}

function dayTaken(room, day) {
	var _this8 = this;

	return room.days.findIndex(function (rd) {
		return _this8.methodIsSameDay(rd.date, day.date) && rd.isTaken;
	}) > -1;
}

function validationAdvancePayment(_ref18) {
	var customer = _ref18.customer;

	var valid = (Number(customer.bookingState) === 4 || Number(customer.bookingState) === 1 || Number(customer.bookingState) === 7) && !this.expiredReservation;
	return valid;
}

function validationCheckOut(_ref19) {
	var customer = _ref19.customer;

	var valid = (Number(customer.bookingState) === 2 || Number(customer.bookingState) === 7) && !this.expiredReservation;
	return valid;
}

function noShowOption(_ref20) {
	var customer = _ref20.customer;

	var bookingStateRight = Number(customer.bookingState) === 1 || Number(customer.bookingState) === 4;
	var noShow = this.isNoShow;
	return bookingStateRight && noShow;
}

function getCheckoutHours(date) {
	var hours = null;
	if (date) {
		var separate = date.split(' ');
		hours = separate[1];
	}
	return hours;
}

function goToBookingNew() {
	this.$router.push({ name: 'booking-new', query: { hotelId: this.subsidiary } });
}

function data() {
	return {
		createHref: { name: 'booking-new' },
		roomTypeIdSelect: [],
		bookingSelected: null,
		cancelModel: {
			description: '',
			title: ''
		},
		checkInQuery: null,
		contentClassModal: '',
		customerInfo: {
			customer: {
				id: null,
				dateRange: [],
				allDaysOnInitMonth: []
			}
		},
		customerSelected: {},
		dateEnd: '',
		dateStart: '',
		daySelected: {},
		doNothing: false,
		footer: [],
		formatted: null,
		freeRooms: [],
		menuBooking: false,
		menuEnd: false,
		menuNewBooking: false,
		menuStart: false,
		modalCancelBooking: false,
		modalNoShowBooking: false,
		modalSeeBooking: false,
		monthId: new Date().getMonth() + 1,
		months: [{
			id: 1,
			name: 'Ene',
			active: false,
			days: []
		}, {
			id: 2,
			name: 'Feb',
			active: false,
			days: []
		}, {
			id: 3,
			name: 'Mar',
			active: false,
			days: []
		}, {
			id: 4,
			name: 'Abr',
			active: false,
			days: []
		}, {
			id: 5,
			name: 'May',
			active: false,
			days: []
		}, {
			id: 6,
			name: 'Jun',
			active: true,
			days: []
		}, {
			id: 7,
			name: 'Jul',
			active: false,
			days: []
		}, {
			id: 8,
			name: 'Ago',
			active: false,
			days: []
		}, {
			id: 9,
			name: 'Sep',
			active: false,
			days: []
		}, {
			id: 10,
			name: 'Oct',
			active: false,
			days: []
		}, {
			id: 11,
			name: 'Nov',
			active: false,
			days: []
		}, {
			id: 12,
			name: 'Dic',
			active: false,
			days: []
		}],
		monthSelected: {},
		newRanges: [],
		noShowDate: false,
		noShowModel: {
			codeBooking: '',
			date: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["format"])(new Date(), 'YYYY-MM-DD'),
			flagBilling: false
		},
		onChange: false,
		onChangeDate: false,
		onChangeEnd: false,
		pickMonths: true,
		roomList: 0,
		rooms: [],
		roomSelected: {},
		roomsList: [],
		roomsTaken: [],
		roomTypes: [],
		roomTypeSelected: 0,
		seeModel: {
			channel: { data: { questions: {} } },
			customer: { data: { country: {} } }
		},
		shortDays: ['dom', 'lun', 'mar', 'mie', 'jue', 'vie', 'sab'],
		showDateBarFixed: false,
		subsidiaries: [],
		subsidiary: 0,
		today: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_date_fns__["format"])(new Date(), 'DD MMMM YYYY', { locale: __WEBPACK_IMPORTED_MODULE_9_date_fns_locale_es___default.a }),
		xBooking: 0,
		xNewBooking: 0,
		yBooking: 0,
		yNewBooking: 0,
		years: [2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027],
		yearSelected: new Date().getFullYear(),
		yearRange: 0
	};
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'cms-calendar',
	components: {
		ButtonCreate: __WEBPACK_IMPORTED_MODULE_6__components_shared_ButtonCreate___default.a,
		amountsComponent: __WEBPACK_IMPORTED_MODULE_13__components_shared_AmountsComponent___default.a,
		generalAvailability: __WEBPACK_IMPORTED_MODULE_14__subComponents_GeneralAvailability___default.a
	},
	computed: {
		arrowIcon: arrowIcon,
		arrowIconEnd: arrowIconEnd,
		arrowIconStart: arrowIconStart,
		expiredReservation: expiredReservation,
		isNoShow: isNoShow
	},
	data: data,
	filters: {
		parseDate: __WEBPACK_IMPORTED_MODULE_12__shared_filters__["b" /* parseDate */],
		round: __WEBPACK_IMPORTED_MODULE_12__shared_filters__["c" /* round */]
	},
	methods: {
		loadAvailability: loadAvailability,
		assignBooking: assignBooking,
		calculateLength: calculateLength,
		cancelBooking: cancelBooking,
		changeEndIcon: changeEndIcon,
		changeFormatDate: changeFormatDate,
		changeIcon: changeIcon,
		changeIconDate: changeIconDate,
		closeBookingModal: closeBookingModal,
		closeMenuBooking: closeMenuBooking,
		closeMenuNew: closeMenuNew,
		daysByMonth: daysByMonth,
		dayTaken: dayTaken,
		downloadCardTravel: downloadCardTravel,
		dragEvent: dragEvent,
		dropEvent: dropEvent,
		fixedBarDateCalculations: fixedBarDateCalculations,
		getCheckoutHours: getCheckoutHours,
		goToBilling: goToBilling,
		goToCheckIn: goToCheckIn,
		goToCheckOut: goToCheckOut,
		goToDetailGuest: goToDetailGuest,
		goToPrepayment: goToPrepayment,
		goToReserve: goToReserve,
		goToUpdateBooking: goToUpdateBooking,
		hideCustomerInfo: hideCustomerInfo,
		isAfterMethod: isAfterMethod,
		loadBooking: loadBooking,
		loadData: loadData,
		loadParams: loadParams,
		loadRoomsList: loadRoomsList,
		loadTypeRooms: loadTypeRooms,
		methodIsAfter: methodIsAfter,
		methodIsSameDay: methodIsSameDay,
		monthActive: monthActive,
		newBooking: newBooking,
		noShowBooking: noShowBooking,
		noShowOption: noShowOption,
		onChangeRoomType: onChangeRoomType,
		onChangeSubsidiary: onChangeSubsidiary,
		openCancelBooking: openCancelBooking,
		openNoShowBooking: openNoShowBooking,
		pickRanges: pickRanges,
		seeBooking: seeBooking,
		setYearSelected: setYearSelected,
		showCustomerInfo: showCustomerInfo,
		showDates: showDates,
		showName: showName,
		toggleIconEndDate: toggleIconEndDate,
		toggleIconStartDate: toggleIconStartDate,
		validationAdvancePayment: validationAdvancePayment,
		validationCheckOut: validationCheckOut,
		validationTakenDay: validationTakenDay,
		goToBookingNew: goToBookingNew
	},
	mixins: __WEBPACK_IMPORTED_MODULE_11__shared_mixins__["a" /* default */],
	mounted: mounted,
	props: ['bookingCode'],
	validations: validations,
	watch: {
		bookingCode: bookingCode
	}
});

/***/ }),

/***/ 1263:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_helper__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_AvaliabilityModal__ = __webpack_require__(1546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_AvaliabilityModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__utils_AvaliabilityModal__);



var getGeneralAvaliabilityInfo = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(checkIn, checkOut, idSubsidiary) {
		var url, params, _ref2, result;

		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						url = '//pms.controlinn.com/api' + '/availabilities/by-roomtypes';
						params = {
							checkIn: checkIn,
							checkOut: checkOut,
							idSubsidiary: idSubsidiary
						};
						_context.next = 4;
						return this.$http.get(url, { params: params });

					case 4:
						_ref2 = _context.sent;
						result = _ref2.data;

						this.typesRooms = result.data.roomTypes;
						this.totalNights = result.data.days;
						this.isLoading = false;

					case 9:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function getGeneralAvaliabilityInfo(_x, _x2, _x3) {
		return _ref.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var formatDate = __WEBPACK_IMPORTED_MODULE_2__shared_helper__["a" /* default */].methods.formatDate;


function showAvaliabilityModal() {
	var showModal = this.rangeDate.length > 0;
	if (showModal) {
		this.isLoading = true;
		var initDate = this.monthSelected.days[this.rangeDate[0]].date;
		this.initDate = formatDate(initDate, 'YYYY-MM-DD');
		var endDate = this.monthSelected.days[this.rangeDate[1]].date;
		this.endDate = formatDate(endDate, 'YYYY-MM-DD');
		this.getGeneralAvaliabilityInfo(this.initDate, this.endDate, this.subsidiaryId);
	}
	return showModal;
}

function initRangeDate(index, range) {
	return range[0] === index;
}

function endRangeDate(index, range) {
	return range[1] === index;
}

function rangeSelected(index, range) {
	return index >= range[0] && index <= range[1];
}

function firstDateSelected(index) {
	return this.clickOne === index;
}

function resetClicks() {
	this.clickOne = null;
	this.clickTwo = null;
}

function buildRangeDate(init, end) {
	this.rangeDate = init <= end ? [init, end] : [end, init];
	this.resetClicks();
}

function selectedDate(index, flag) {
	if (!flag) {
		this.rangeDate = [];
		this.clickOne = index;
	} else {
		this.clickTwo = index;
	}
	if (this.clickOne !== null && this.clickTwo !== null) {
		this.buildRangeDate(this.clickOne, this.clickTwo);
	}
	this.flagActiveDate = !this.flagActiveDate;
}

function ceroValue(value) {
	return value === 0;
}

function data() {
	return {
		clickTwo: null,
		clickOne: null,
		endDate: '',
		flagActiveDate: false,
		initDate: '',
		isLoading: false,
		rangeDate: [],
		typesRooms: [],
		totalNights: ''
	};
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'general-availability',
	components: {
		avaliabilityModal: __WEBPACK_IMPORTED_MODULE_3__utils_AvaliabilityModal___default.a
	},
	computed: {
		showAvaliabilityModal: showAvaliabilityModal
	},
	data: data,
	methods: {
		buildRangeDate: buildRangeDate,
		ceroValue: ceroValue,
		endRangeDate: endRangeDate,
		firstDateSelected: firstDateSelected,
		getGeneralAvaliabilityInfo: getGeneralAvaliabilityInfo,
		initRangeDate: initRangeDate,
		rangeSelected: rangeSelected,
		resetClicks: resetClicks,
		selectedDate: selectedDate
	},
	props: {
		freeRooms: {
			default: function _default() {
				return [];
			},
			type: Array
		},
		subsidiaryId: {
			default: 0,
			type: Number
		},
		monthSelected: {
			default: function _default() {},
			type: Object
		}
	}
});

/***/ }),

/***/ 1264:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_mixins__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__clerkinn_shared_input_text__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__clerkinn_shared_input_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__clerkinn_shared_input_text__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function mounted() {
	var index = this.calculatePosition;
	var displaceModal = index * this.blockWidth + (this.blockWidth - this.modalWidth) / 2;
	var ele = document.getElementById('avaliability-modal');
	ele.style.transform = 'translateX(' + displaceModal + 'px)';
}

function avaliabilityCero() {
	return this.roomQuantity && this.roomQuantity > 0;
}

function goToReserve(initDate, endDate, hotelId, _ref, reservation) {
	var id = _ref.id,
	    total = _ref.total;

	var numReserve = reservation;
	var todayMiliseconds = Date.parse(new Date());
	var initDateMiliseconds = Date.parse(new Date(initDate));
	if (todayMiliseconds < initDateMiliseconds) {
		var query = {
			initDate: initDate,
			endDate: endDate,
			hotelId: hotelId,
			roomTypeId: id,
			numReserve: numReserve
		};
		if (reservation === 1) {
			this.$router.push({ name: 'booking-new', query: query });
		} else {
			this.$router.push({ name: 'select-rooms', query: query });
		}
	} else {
		this.showNotification('No se pueden crear reservas en fechas anteriores a la actual. Modifica tu selección.', 'error');
	}
}

function data() {
	return {
		blockWidth: 43,
		controlinnLogo: '/static/img/logo-control-inn.png',
		modalWidth: 230,
		rooms: [1, 2, 3, 4, 5, 6, 7, 8, 9],
		roomQuantity: null
	};
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'avaliability-modal',
	components: {
		inputText: __WEBPACK_IMPORTED_MODULE_1__clerkinn_shared_input_text___default.a
	},
	computed: {
		avaliabilityCero: avaliabilityCero
	},
	data: data,
	methods: {
		goToReserve: goToReserve
	},
	mixins: __WEBPACK_IMPORTED_MODULE_0__shared_mixins__["a" /* default */],
	mounted: mounted,
	props: {
		calculatePosition: {
			default: null,
			type: Number
		},
		endDate: {
			default: '',
			type: String
		},
		initDate: {
			default: '',
			type: String
		},
		isLoading: {
			deafult: false,
			type: Boolean
		},
		roomsType: {
			default: function _default() {
				return [];
			},
			type: Array
		},
		subsidiary: {
			default: 0,
			type: Number
		},
		totalNights: {
			default: '',
			type: [String, Number]
		}
	}
});

/***/ }),

/***/ 1363:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(772)(true);
// imports


// module
exports.push([module.i, ".modal[data-v-02ac0c9e]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:#efefef;border-radius:6px;bottom:2.5em;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;height:240px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:3px 10px;position:absolute;width:230px;z-index:2}.modal[data-v-02ac0c9e]:before{bottom:-16px;border-color:transparent;border-style:solid solid outset;border-top-color:#efefef;border-width:8px;content:\" \";display:block;height:0;left:107px;position:absolute;width:0}.modal-header-date[data-v-02ac0c9e]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#a4a4a4;display:-webkit-box;display:-ms-flexbox;display:flex;font-family:San Francisco Display Medium;font-size:12px;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:5px;width:100%}.total-nights[data-v-02ac0c9e]{background-color:#000;color:#fff;font-family:San Francisco Display Semi Bold;padding:0 3px}.modal-content[data-v-02ac0c9e]{background-color:#fff;height:100%;padding:6px 15px;width:100%}.type-room[data-v-02ac0c9e]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;border-top:2px solid #979797;color:#a4a4a4;display:-webkit-box;display:-ms-flexbox;display:flex;height:36px;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:0 5px}.type-room p[data-v-02ac0c9e]{margin:0}.reservation-btn[data-v-02ac0c9e]{height:23px}.reservation-btn button.btn[data-v-02ac0c9e]{height:100%}.btn-save[data-v-02ac0c9e]{min-width:100%!important}.room[data-v-02ac0c9e]{width:55px}.rooms-quantity[data-v-02ac0c9e]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:0 5px}.rooms-quantity p[data-v-02ac0c9e]{margin:0;white-space:nowrap;width:auto}", "", {"version":3,"sources":["/opt/build/repo/src/clerkinn/calendar/utils/AvaliabilityModal.vue"],"names":[],"mappings":"AACA,wBACE,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,yBAA0B,AAC1B,kBAAmB,AACnB,aAAc,AACd,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,iBAAkB,AAClB,kBAAmB,AACnB,YAAa,AACb,SAAW,CACZ,AACD,+BACE,aAAc,AACd,yBAA0B,AAC1B,gCAAiC,AACjC,yBAA0B,AAC1B,iBAAkB,AAClB,YAAa,AACb,cAAe,AACf,SAAU,AACV,WAAY,AACZ,kBAAmB,AACnB,OAAS,CACV,AACD,oCACE,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,cAAe,AACf,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yCAA4C,AAC5C,eAAgB,AAChB,yBAA0B,AACtB,sBAAuB,AACnB,8BAA+B,AACvC,kBAAmB,AACnB,UAAY,CACb,AACD,+BACE,sBAAwB,AACxB,WAAa,AACb,4CAA+C,AAC/C,aAAe,CAChB,AACD,gCACE,sBAAwB,AACxB,YAAa,AACb,iBAAkB,AAClB,UAAY,CACb,AACD,4BACE,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,6BAA8B,AAC9B,cAAe,AACf,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,YAAa,AACb,yBAA0B,AACtB,sBAAuB,AACnB,8BAA+B,AACvC,aAAe,CAChB,AACD,8BACI,QAAU,CACb,AACD,kCACE,WAAa,CACd,AACD,6CACI,WAAa,CAChB,AACD,2BACE,wBAA2B,CAC5B,AACD,uBACE,UAAY,CACb,AACD,iCACE,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,8BAA+B,AACvC,aAAe,CAChB,AACD,mCACI,SAAU,AACV,mBAAoB,AACpB,UAAY,CACf","file":"AvaliabilityModal.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\n.modal[data-v-02ac0c9e] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  background-color: #efefef;\n  border-radius: 6px;\n  bottom: 2.5em;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  height: 240px;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  padding: 3px 10px;\n  position: absolute;\n  width: 230px;\n  z-index: 2;\n}\n.modal[data-v-02ac0c9e]::before {\n  bottom: -16px;\n  border-color: transparent;\n  border-style: solid solid outset;\n  border-top-color: #efefef;\n  border-width: 8px;\n  content: \" \";\n  display: block;\n  height: 0;\n  left: 107px;\n  position: absolute;\n  width: 0;\n}\n.modal-header-date[data-v-02ac0c9e] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  color: #a4a4a4;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  font-family: \"San Francisco Display Medium\";\n  font-size: 12px;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-bottom: 5px;\n  width: 100%;\n}\n.total-nights[data-v-02ac0c9e] {\n  background-color: black;\n  color: white;\n  font-family: \"San Francisco Display Semi Bold\";\n  padding: 0 3px;\n}\n.modal-content[data-v-02ac0c9e] {\n  background-color: white;\n  height: 100%;\n  padding: 6px 15px;\n  width: 100%;\n}\n.type-room[data-v-02ac0c9e] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  border-top: 2px solid #979797;\n  color: #a4a4a4;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 36px;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  padding: 0 5px;\n}\n.type-room p[data-v-02ac0c9e] {\n    margin: 0;\n}\n.reservation-btn[data-v-02ac0c9e] {\n  height: 23px;\n}\n.reservation-btn button.btn[data-v-02ac0c9e] {\n    height: 100%;\n}\n.btn-save[data-v-02ac0c9e] {\n  min-width: 100% !important;\n}\n.room[data-v-02ac0c9e] {\n  width: 55px;\n}\n.rooms-quantity[data-v-02ac0c9e] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  padding: 0 5px;\n}\n.rooms-quantity p[data-v-02ac0c9e] {\n    margin: 0;\n    white-space: nowrap;\n    width: auto;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1398:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(772)(true);
// imports


// module
exports.push([module.i, ".add-new[data-v-49686237]{color:#ededf3;font-size:30px;line-height:normal}.container-calendar[data-v-49686237]{background-color:#fff;height:calc(100vh - 130px);padding:16px 10px 11px}.base-calendar[data-v-49686237]{border-collapse:collapse;border-spacing:0;display:block;height:calc(100vh - 233px);overflow:auto;width:100%}.thead-calendar[data-v-49686237]{border:1px solid #dadada;display:block;height:100%}.main-row[data-v-49686237]{display:block;height:100%;position:relative}.main-row[data-v-49686237]:after,.main-row[data-v-49686237]:before{display:table;content:\"\"}.main-row[data-v-49686237]:after{clear:both}.row-calendar[data-v-49686237]{display:table;width:100%}.row-calendar.row-calendar-body[data-v-49686237]{display:-webkit-box;display:-ms-flexbox;display:flex;height:40px;position:relative}.row-calendar.row-calendar-body .col-calendar-1[data-v-49686237]{border:.5px solid #dadada;min-width:43px;padding:0;width:100%}.row-calendar.row-calendar-body .col-calendar-1.day-is-weekend[data-v-49686237]{background-color:#fafafa}.row-calendar.row-calendar-body .col-calendar-1.day-is-selected:not(.day-is-taken) .tag-container[data-v-49686237]{border:2px solid #29abe2}.row-calendar.row-calendar-body .col-calendar-1.day-is-selected .tag-container:not(.no-tag)+.tag-container.no-tag[data-v-49686237]{border:0}.row-calendar.row-calendar-body .col-calendar-1.day-is-selected.day-is-taken .tag-end-day[data-v-49686237]:after,.row-calendar.row-calendar-body .col-calendar-1.day-is-selected.day-is-taken .tag-init-day[data-v-49686237]:after{border:2px solid #29abe2;content:\"\";display:block;height:100%;position:relative;width:60%}.row-calendar.row-calendar-body .col-calendar-1.day-is-selected.day-is-taken .tag-end-day[data-v-49686237]:after{left:24px}.row-calendar.row-calendar-body .col-calendar-1.day-is-selected.day-is-taken .tag-init-day[data-v-49686237]:after{left:-27px;width:100%}.row-calendar.row-calendar-body .col-calendar-1[data-v-49686237]:last-child{overflow:hidden}.row-calendar.row-calendar-body[data-v-49686237]:nth-child(2){height:41px}.row-calendar.row-calendar-body:nth-child(2) .col-calendar-1[data-v-49686237]{border-top:2px solid #dadada}.row-calendar.row-calendar-body:nth-last-child(3) .col-calendar-1[data-v-49686237]{border-bottom:2px solid #dadada;height:41px}.row-calendar.row-calendar-footer[data-v-49686237]{display:-webkit-box;display:-ms-flexbox;display:flex;height:18.5px}.row-calendar.row-calendar-footer .col-calendar-1[data-v-49686237]{background-color:#303645;min-width:43px;width:100%}.row-calendar.row-calendar-footer .col-calendar-1 .text-footer[data-v-49686237]{color:#fff;font-family:San Francisco Display Bold;font-size:11px;line-height:2;padding:0;text-align:center}.row-calendar.row-calendar-footer:last-child .col-calendar-1 .text-footer[data-v-49686237]{font-size:9px}.row-calendar.row-rooms[data-v-49686237]{border-bottom:2px solid #dadada;border-right:.5px solid #dadada;color:#566074;font-family:San Francisco Display Medium;font-size:13px;height:38px;line-height:38px;text-align:left}.row-calendar.row-rooms[data-v-49686237]:nth-child(3){border-top:1px solid #dadada}.row-calendar.row-rooms .row-rooms-text[data-v-49686237]{padding-left:6px}.row-calendar.row-days[data-v-49686237]{display:-webkit-box;display:-ms-flexbox;display:flex}.row-calendar.row-days .col-calendar-1[data-v-49686237]{color:#828282;line-height:13px;min-width:43px;width:100%}.row-calendar.row-days .col-calendar-1 p[data-v-49686237]{font-family:San Francisco Display;font-size:11px;margin:0}.row-calendar.row-days .col-calendar-1 span[data-v-49686237]{font-family:San Francisco Display Semi Bold;font-size:12px}.row-calendar.row-left[data-v-49686237]{width:111px}.row-calendar.row-left-footer[data-v-49686237]{border-right:2px solid #dadada;background-color:#303645;height:18.5px;width:112px}.row-calendar.row-left-footer .text-footer[data-v-49686237]{color:#fff;font-family:San Francisco Display Bold}.row-calendar .text-footer[data-v-49686237]{color:#828282;font-size:12px;padding-left:7px;text-align:left}.row-calendar.row-calendar-total-availability[data-v-49686237]{height:auto}.col-calendar[data-v-49686237]{display:table-cell;vertical-align:middle}.col-calendar-4[data-v-49686237]{float:left;height:auto;width:111px}.col-calendar-31[data-v-49686237]{-ms-flex-item-align:center;align-self:center;float:left;height:auto;overflow:auto;position:relative;width:calc(100% - 111px)}.col-calendar-1[data-v-49686237]{width:3.22581%}p[data-v-49686237]{margin:0}.tag[data-v-49686237]{display:block;height:26.5px;line-height:26.5px;margin:0!important;padding:0;position:absolute;text-align:left;-webkit-transform:skewX(-28deg);transform:skewX(-28deg);width:106%}.tag.z-index[data-v-49686237]{z-index:1}.tag-init-day[data-v-49686237]{left:auto;padding-left:5px;right:-10px;width:54%;z-index:1}.tag span.tag-name[data-v-49686237]{color:#fff;overflow:hidden;position:absolute;-webkit-transform:skewX(28deg);transform:skewX(28deg);white-space:nowrap;width:-webkit-max-content;width:-moz-max-content;width:max-content;z-index:1}.tag-end-day[data-v-49686237]{left:-1px;right:auto;-webkit-transform:skewX(-28deg);transform:skewX(-28deg);width:50%}.tag-container[data-v-49686237]{height:27px;margin-top:5.5px;position:relative}.tag-information[data-v-49686237]{background-color:hsla(0,0%,100%,.96);border:.5px solid #a4a4a4;border-radius:10px;-webkit-box-shadow:0 2px 4px 0 rgba(0,0,0,.2);box-shadow:0 2px 4px 0 rgba(0,0,0,.2);padding:14px 18px;position:absolute;right:-120px;top:20px;width:219px;z-index:2}.tag-information .title[data-v-49686237]{color:#2e394b;font-family:San Francisco Display Bold;font-size:14px;margin-bottom:8px;text-align:left;text-transform:uppercase}.tag-information .content-row[data-v-49686237]{font-family:San Francisco Display Medium;font-size:14px;margin-top:10px;text-align:left}.tag-information .content-row label[data-v-49686237]{color:#29abe2;font-family:San Francisco Display Bold}.tag-information .content-row span[data-v-49686237]{color:gray}.tag-menu-modal[data-v-49686237]{height:100%;width:100%}.tag-menu-title[data-v-49686237]{color:#2e394b;font-family:San Francisco Display Bold;font-size:14px}.tag-menu-body label[data-v-49686237]{color:#29abe2;font-family:San Francisco Display Bold;font-size:14px}.tag-menu-body span[data-v-49686237]{color:#9b9b9b;font-family:San Francisco Display;font-size:14px}.tag-menu-sidebar[data-v-49686237]{border-bottom-left-radius:10px;border-bottom-right-radius:10px;height:100%}.tag-menu-sidebar .list__tile__action[data-v-49686237],.tag-menu-sidebar .list__tile__title[data-v-49686237]{color:#2f302f;font-family:San Francisco Display;font-size:12px}.tag-menu-sidebar .list__tile__action[data-v-49686237]{color:#8b9293;padding-left:16px}.tag-menu-sidebar .list__tile__action i[data-v-49686237]{font-size:16px}.tag-menu-sidebar li[data-v-49686237]{border-bottom:1px solid rgba(0,0,0,.12)}.tag-menu-sidebar li[data-v-49686237]:last-child{border-bottom:0}.tag-menu-border[data-v-49686237]{border-right:1px solid rgba(0,0,0,.12)}.select[data-v-49686237]{position:relative;text-align:left}.select select.select-roomtype[data-v-49686237]{color:#8094a0;font-size:11px;height:27px;outline:none;position:relative;width:100%}.header-booking-data[data-v-49686237]{height:31px;position:absolute;right:20px;text-align:right;top:52px;width:calc(100% - 230px)}.header-booking-data-calendar[data-v-49686237]{margin:0!important;position:static;width:100%}.header-booking-data div[data-v-49686237]{padding-bottom:0!important;padding-top:0!important}.header-booking-data p[data-v-49686237]{color:#2e394b;font-family:San Francisco Display;font-size:10px;margin:0;text-transform:uppercase}.header-booking-data span[data-v-49686237]{color:#29abe2;font-family:San Francisco Display Medium;font-size:15px}.header-booking-data .border-select[data-v-49686237]{border-right:1px solid #979797;margin-right:16px;padding-right:16px!important}.tasks-calendar-header[data-v-49686237]{margin-bottom:16px}.tasks-calendar-header .title[data-v-49686237]{color:#545e72;font-family:San Francisco Display Medium;font-size:11px!important;text-align:left}.tasks-calendar-header .period[data-v-49686237]{text-align:right}.tasks-calendar-header .period label[data-v-49686237]{color:#828282;font-family:San Francisco Display;font-size:14px;margin-left:14px}.tasks-calendar-header .period .active[data-v-49686237]{border-bottom:1px solid #545e72;color:#545e72;font-family:San Francisco Display Medium}.tasks-calendar-header .period .select[data-v-49686237]{border-left:1px solid #e2e2e2;display:inline-block;height:13px;line-height:13px;margin-left:4px;position:relative;text-align:left;width:52px}.tasks-calendar-header .period .select.select-calendar[data-v-49686237]{width:auto}.tasks-calendar-header .button-ranges[data-v-49686237]{border-radius:5px;-webkit-box-shadow:0 2px 4px 0 rgba(0,0,0,.18);box-shadow:0 2px 4px 0 rgba(0,0,0,.18);color:#545e72;outline:none;padding:0 8px}.assign-room[data-v-49686237]{min-width:auto!important}.size-btn[data-v-49686237]{height:auto;width:auto}.mb-8[data-v-49686237]{margin-bottom:8px}.border-right[data-v-49686237]{border-right:1px solid #d8d8d8}.caption .color[data-v-49686237]{border-radius:3px;display:inline-block;height:10px;margin-right:4px;vertical-align:middle;width:10px}.caption .color.check-in[data-v-49686237]{background-color:#0fe270}.caption .color.check-out[data-v-49686237]{background-color:#ff0053}.caption .color.taken[data-v-49686237]{background-color:#00b5ef}.caption .color.locked[data-v-49686237]{background-color:#a5aeb0}.caption .color.in-house[data-v-49686237]{background-color:#353b51}.caption .title[data-v-49686237]{color:#545e72;font-family:San Francisco Display;font-size:14px;vertical-align:middle}.taken-bar[data-v-49686237]{color:#c3c3c3;font-family:San Francisco Display Medium;font-size:11px}.row-taken-bar .col-calendar[data-v-49686237],.row-taken-bar[data-v-49686237]{background-color:#eefffa}.btn-cancel.grey[data-v-49686237]{background-color:#9b9b9b!important}.headline[data-v-49686237]{border-bottom:1px solid #e1e1e1;color:#818181;font-family:San Francisco Display;font-size:14px!important;text-transform:capitalize}.headline-title[data-v-49686237]{color:#353c4c;font-size:18px;font-weight:400;margin:0;text-transform:none}.headline-label[data-v-49686237]{color:#545e72;font-family:San Francisco Display Medium}.bar-data[data-v-49686237]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:#fff;-webkit-box-shadow:0 2px 5px 0 rgba(0,0,0,.1);box-shadow:0 2px 5px 0 rgba(0,0,0,.1);display:-webkit-box;display:-ms-flexbox;display:flex;height:48px;-ms-flex-pack:distribute;justify-content:space-around}.bar-data-item[data-v-49686237]{border-right:1px solid #e2e2e2;-webkit-box-flex:1;-ms-flex:1 auto;flex:1 auto}.bar-data-item.no-border[data-v-49686237],.bar-data-item[data-v-49686237]:last-of-type{border-right:0}.bar-data-item p[data-v-49686237]{color:#545e72;font-family:San Francisco Display Medium;font-size:14px;margin-bottom:0}.bar-data-item p span[data-v-49686237]{color:#818181;font-family:San Francisco Display;font-size:14px}.bar-data .bar-icon[data-v-49686237]{font-size:20px;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;width:20px}.modal-label[data-v-49686237]{color:#2f302f;font-family:San Francisco Display Medium;font-size:14px}.modal-text[data-v-49686237]{color:#2f302f;font-family:San Francisco Display;font-size:14px}.date-bar-fixed[data-v-49686237]{height:27px;position:-webkit-sticky;position:sticky;top:0;z-index:4}", "", {"version":3,"sources":["/opt/build/repo/src/clerkinn/calendar/CmsCalendar.vue"],"names":[],"mappings":"AACA,0BACE,cAAe,AACf,eAAgB,AAChB,kBAAoB,CACrB,AACD,qCACE,sBAAwB,AACxB,2BAA4B,AAC5B,sBAAwB,CACzB,AACD,gCACE,yBAA0B,AAC1B,iBAAkB,AAClB,cAAe,AACf,2BAA4B,AAC5B,cAAe,AACf,UAAY,CACb,AACD,iCACE,yBAA0B,AAC1B,cAAe,AACf,WAAa,CACd,AACD,2BACE,cAAe,AACf,YAAa,AACb,iBAAmB,CACpB,AACD,mEACI,cAAe,AACf,UAAY,CACf,AACD,iCACI,UAAY,CACf,AACD,+BACE,cAAe,AACf,UAAY,CACb,AACD,iDACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,YAAa,AACb,iBAAmB,CACtB,AACD,iEACM,0BAA4B,AAC5B,eAAgB,AAChB,UAAa,AACb,UAAY,CACjB,AACD,gFACQ,wBAA0B,CACjC,AACD,mHACQ,wBAA0B,CACjC,AACD,mIACQ,QAAY,CACnB,AACD,mOAEQ,yBAA0B,AAC1B,WAAY,AACZ,cAAe,AACf,YAAa,AACb,kBAAmB,AACnB,SAAW,CAClB,AACD,iHACQ,SAAW,CAClB,AACD,kHACQ,WAAY,AACZ,UAAY,CACnB,AACD,4EACQ,eAAiB,CACxB,AACD,8DACM,WAAa,CAClB,AACD,8EACQ,4BAA8B,CACrC,AACD,mFACM,gCAAiC,AACjC,WAAa,CAClB,AACD,mDACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,aAAe,CAClB,AACD,mEACM,yBAA0B,AAC1B,eAAgB,AAChB,UAAY,CACjB,AACD,gFACQ,WAAa,AACb,uCAA0C,AAC1C,eAAgB,AAChB,cAAe,AACf,UAAa,AACb,iBAAmB,CAC1B,AACD,2FACM,aAAe,CACpB,AACD,yCACI,gCAAiC,AACjC,gCAAkC,AAClC,cAAe,AACf,yCAA4C,AAC5C,eAAgB,AAChB,YAAa,AACb,iBAAkB,AAClB,eAAiB,CACpB,AACD,sDACM,4BAA8B,CACnC,AACD,yDACM,gBAAkB,CACvB,AACD,wCACI,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACjB,AACD,wDACM,cAAe,AACf,iBAAkB,AAClB,eAAgB,AAChB,UAAY,CACjB,AACD,0DACQ,kCAAqC,AACrC,eAAgB,AAChB,QAAY,CACnB,AACD,6DACQ,4CAA+C,AAC/C,cAAgB,CACvB,AACD,wCACI,WAAa,CAChB,AACD,+CACM,+BAAgC,AAChC,yBAA0B,AAC1B,cAAe,AACf,WAAa,CAClB,AACD,4DACQ,WAAa,AACb,sCAA0C,CACjD,AACD,4CACI,cAAe,AACf,eAAgB,AAChB,iBAAkB,AAClB,eAAiB,CACpB,AACD,+DACI,WAAa,CAChB,AACD,+BACE,mBAAoB,AACpB,qBAAuB,CACxB,AACD,iCACI,WAAY,AACZ,YAAa,AACb,WAAa,CAChB,AACD,kCACI,2BAA4B,AACxB,kBAAmB,AACvB,WAAY,AACZ,YAAa,AACb,cAAe,AACf,kBAAmB,AACnB,wBAA0B,CAC7B,AACD,iCACI,cAAuB,CAC1B,AACD,mBACE,QAAY,CACb,AACD,sBACE,cAAe,AACf,cAAe,AACf,mBAAoB,AACpB,mBAAqB,AACrB,UAAa,AACb,kBAAmB,AACnB,gBAAiB,AACjB,gCAAiC,AACzB,wBAAyB,AACjC,UAAY,CACb,AACD,8BACI,SAAW,CACd,AACD,+BACI,UAAW,AACX,iBAAkB,AAClB,YAAa,AACb,UAAW,AACX,SAAW,CACd,AACD,oCACI,WAAa,AACb,gBAAiB,AACjB,kBAAmB,AACnB,+BAAgC,AACxB,uBAAwB,AAChC,mBAAoB,AACpB,0BAA2B,AAC3B,uBAAwB,AACxB,kBAAmB,AACnB,SAAW,CACd,AACD,8BACI,UAAW,AACX,WAAY,AACZ,gCAAiC,AACzB,wBAAyB,AACjC,SAAW,CACd,AACD,gCACI,YAAa,AACb,iBAAkB,AAClB,iBAAmB,CACtB,AACD,kCACI,qCAA4C,AAC5C,0BAA4B,AAC5B,mBAAoB,AACpB,8CAAmD,AAC3C,sCAA2C,AACnD,kBAAmB,AACnB,kBAAmB,AACnB,aAAc,AACd,SAAU,AACV,YAAa,AACb,SAAW,CACd,AACD,yCACM,cAAe,AACf,uCAA0C,AAC1C,eAAgB,AAChB,kBAAmB,AACnB,gBAAiB,AACjB,wBAA0B,CAC/B,AACD,+CACM,yCAA4C,AAC5C,eAAgB,AAChB,gBAAiB,AACjB,eAAiB,CACtB,AACD,qDACQ,cAAe,AACf,sCAA0C,CACjD,AACD,oDACQ,UAAe,CACtB,AACD,iCACI,YAAa,AACb,UAAY,CACf,AACD,iCACI,cAAe,AACf,uCAA0C,AAC1C,cAAgB,CACnB,AACD,sCACI,cAAe,AACf,uCAA0C,AAC1C,cAAgB,CACnB,AACD,qCACI,cAAe,AACf,kCAAqC,AACrC,cAAgB,CACnB,AACD,mCACI,+BAAgC,AAChC,gCAAiC,AACjC,WAAa,CAChB,AACD,6GAEM,cAAe,AACf,kCAAqC,AACrC,cAAgB,CACrB,AACD,uDACM,cAAe,AACf,iBAAmB,CACxB,AACD,yDACQ,cAAgB,CACvB,AACD,sCACM,uCAA6C,CAClD,AACD,iDACQ,eAAmB,CAC1B,AACD,kCACI,sCAA4C,CAC/C,AACD,yBACE,kBAAmB,AACnB,eAAiB,CAClB,AACD,gDACI,cAAe,AACf,eAAgB,AAChB,YAAa,AACb,aAAc,AACd,kBAAmB,AACnB,UAAY,CACf,AACD,sCACE,YAAa,AACb,kBAAmB,AACnB,WAAY,AACZ,iBAAkB,AAClB,SAAU,AACV,wBAA0B,CAC3B,AACD,+CACI,mBAAuB,AACvB,gBAAiB,AACjB,UAAY,CACf,AACD,0CACI,2BAA+B,AAC/B,uBAA4B,CAC/B,AACD,wCACI,cAAe,AACf,kCAAqC,AACrC,eAAgB,AAChB,SAAY,AACZ,wBAA0B,CAC7B,AACD,2CACI,cAAe,AACf,yCAA4C,AAC5C,cAAgB,CACnB,AACD,qDACI,+BAAgC,AAChC,kBAAmB,AACnB,4BAA+B,CAClC,AACD,wCACE,kBAAoB,CACrB,AACD,+CACI,cAAe,AACf,yCAA4C,AAC5C,yBAA2B,AAC3B,eAAiB,CACpB,AACD,gDACI,gBAAkB,CACrB,AACD,sDACM,cAAe,AACf,kCAAqC,AACrC,eAAgB,AAChB,gBAAkB,CACvB,AACD,wDACM,gCAAiC,AACjC,cAAe,AACf,wCAA4C,CACjD,AACD,wDACM,8BAA+B,AAC/B,qBAAsB,AACtB,YAAa,AACb,iBAAkB,AAClB,gBAAiB,AACjB,kBAAmB,AACnB,gBAAiB,AACjB,UAAY,CACjB,AACD,wEACQ,UAAY,CACnB,AACD,uDACI,kBAAmB,AACnB,+CAAwD,AAChD,uCAAgD,AACxD,cAAe,AACf,aAAc,AACd,aAAiB,CACpB,AACD,8BACE,wBAA2B,CAC5B,AACD,2BACE,YAAa,AACb,UAAY,CACb,AACD,uBACE,iBAAmB,CACpB,AACD,+BACE,8BAAgC,CACjC,AACD,iCACE,kBAAmB,AACnB,qBAAsB,AACtB,YAAa,AACb,iBAAkB,AAClB,sBAAuB,AACvB,UAAY,CACb,AACD,0CACI,wBAA0B,CAC7B,AACD,2CACI,wBAA0B,CAC7B,AACD,uCACI,wBAA0B,CAC7B,AACD,wCACI,wBAA0B,CAC7B,AACD,0CACI,wBAA0B,CAC7B,AACD,iCACE,cAAe,AACf,kCAAqC,AACrC,eAAgB,AAChB,qBAAuB,CACxB,AACD,4BACE,cAAe,AACf,yCAA4C,AAC5C,cAAgB,CACjB,AAID,8EACI,wBAA0B,CAC7B,AACD,kCACE,kCAAqC,CACtC,AACD,2BACE,gCAAiC,AACjC,cAAe,AACf,kCAAqC,AACrC,yBAA2B,AAC3B,yBAA2B,CAC5B,AACD,iCACI,cAAe,AACf,eAAgB,AAChB,gBAAoB,AACpB,SAAY,AACZ,mBAAqB,CACxB,AACD,iCACI,cAAe,AACf,wCAA4C,CAC/C,AACD,2BACE,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,sBAAwB,AACxB,8CAAmD,AAC3C,sCAA2C,AACnD,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,YAAa,AACb,yBAA0B,AACtB,4BAA8B,CACnC,AACD,gCACI,+BAAgC,AAChC,mBAAoB,AAChB,gBAAiB,AACb,WAAa,CACxB,AAID,uFACM,cAAkB,CACvB,AACD,kCACM,cAAe,AACf,yCAA4C,AAC5C,eAAgB,AAChB,eAAmB,CACxB,AACD,uCACQ,cAAe,AACf,kCAAqC,AACrC,cAAgB,CACvB,AACD,qCACI,eAAgB,AAChB,uBAAwB,AACpB,oBAAqB,AACjB,2BAA4B,AACpC,UAAY,CACf,AACD,8BACE,cAAe,AACf,yCAA4C,AAC5C,cAAgB,CACjB,AACD,6BACE,cAAe,AACf,kCAAqC,AACrC,cAAgB,CACjB,AACD,iCACE,YAAa,AACb,wBAAyB,AACzB,gBAAiB,AACjB,MAAO,AACP,SAAW,CACZ","file":"CmsCalendar.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\n.add-new[data-v-49686237] {\n  color: #ededf3;\n  font-size: 30px;\n  line-height: normal;\n}\n.container-calendar[data-v-49686237] {\n  background-color: white;\n  height: calc(100vh - 130px);\n  padding: 16px 10px 11px;\n}\n.base-calendar[data-v-49686237] {\n  border-collapse: collapse;\n  border-spacing: 0;\n  display: block;\n  height: calc(100vh - 233px);\n  overflow: auto;\n  width: 100%;\n}\n.thead-calendar[data-v-49686237] {\n  border: 1px solid #dadada;\n  display: block;\n  height: 100%;\n}\n.main-row[data-v-49686237] {\n  display: block;\n  height: 100%;\n  position: relative;\n}\n.main-row[data-v-49686237]:before, .main-row[data-v-49686237]:after {\n    display: table;\n    content: '';\n}\n.main-row[data-v-49686237]:after {\n    clear: both;\n}\n.row-calendar[data-v-49686237] {\n  display: table;\n  width: 100%;\n}\n.row-calendar.row-calendar-body[data-v-49686237] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    height: 40px;\n    position: relative;\n}\n.row-calendar.row-calendar-body .col-calendar-1[data-v-49686237] {\n      border: 0.5px solid #dadada;\n      min-width: 43px;\n      padding: 0px;\n      width: 100%;\n}\n.row-calendar.row-calendar-body .col-calendar-1.day-is-weekend[data-v-49686237] {\n        background-color: #fafafa;\n}\n.row-calendar.row-calendar-body .col-calendar-1.day-is-selected:not(.day-is-taken) .tag-container[data-v-49686237] {\n        border: 2px solid #29abe2;\n}\n.row-calendar.row-calendar-body .col-calendar-1.day-is-selected .tag-container:not(.no-tag) + .tag-container.no-tag[data-v-49686237] {\n        border: 0px;\n}\n.row-calendar.row-calendar-body .col-calendar-1.day-is-selected.day-is-taken .tag-init-day[data-v-49686237]:after,\n      .row-calendar.row-calendar-body .col-calendar-1.day-is-selected.day-is-taken .tag-end-day[data-v-49686237]:after {\n        border: 2px solid #29abe2;\n        content: '';\n        display: block;\n        height: 100%;\n        position: relative;\n        width: 60%;\n}\n.row-calendar.row-calendar-body .col-calendar-1.day-is-selected.day-is-taken .tag-end-day[data-v-49686237]:after {\n        left: 24px;\n}\n.row-calendar.row-calendar-body .col-calendar-1.day-is-selected.day-is-taken .tag-init-day[data-v-49686237]:after {\n        left: -27px;\n        width: 100%;\n}\n.row-calendar.row-calendar-body .col-calendar-1[data-v-49686237]:last-child {\n        overflow: hidden;\n}\n.row-calendar.row-calendar-body[data-v-49686237]:nth-child(2) {\n      height: 41px;\n}\n.row-calendar.row-calendar-body:nth-child(2) .col-calendar-1[data-v-49686237] {\n        border-top: 2px solid #dadada;\n}\n.row-calendar.row-calendar-body:nth-last-child(3) .col-calendar-1[data-v-49686237] {\n      border-bottom: 2px solid #dadada;\n      height: 41px;\n}\n.row-calendar.row-calendar-footer[data-v-49686237] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    height: 18.5px;\n}\n.row-calendar.row-calendar-footer .col-calendar-1[data-v-49686237] {\n      background-color: #303645;\n      min-width: 43px;\n      width: 100%;\n}\n.row-calendar.row-calendar-footer .col-calendar-1 .text-footer[data-v-49686237] {\n        color: white;\n        font-family: \"San Francisco Display Bold\";\n        font-size: 11px;\n        line-height: 2;\n        padding: 0px;\n        text-align: center;\n}\n.row-calendar.row-calendar-footer:last-child .col-calendar-1 .text-footer[data-v-49686237] {\n      font-size: 9px;\n}\n.row-calendar.row-rooms[data-v-49686237] {\n    border-bottom: 2px solid #dadada;\n    border-right: 0.5px solid #dadada;\n    color: #566074;\n    font-family: \"San Francisco Display Medium\";\n    font-size: 13px;\n    height: 38px;\n    line-height: 38px;\n    text-align: left;\n}\n.row-calendar.row-rooms[data-v-49686237]:nth-child(3) {\n      border-top: 1px solid #dadada;\n}\n.row-calendar.row-rooms .row-rooms-text[data-v-49686237] {\n      padding-left: 6px;\n}\n.row-calendar.row-days[data-v-49686237] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.row-calendar.row-days .col-calendar-1[data-v-49686237] {\n      color: #828282;\n      line-height: 13px;\n      min-width: 43px;\n      width: 100%;\n}\n.row-calendar.row-days .col-calendar-1 p[data-v-49686237] {\n        font-family: \"San Francisco Display\";\n        font-size: 11px;\n        margin: 0px;\n}\n.row-calendar.row-days .col-calendar-1 span[data-v-49686237] {\n        font-family: \"San Francisco Display Semi Bold\";\n        font-size: 12px;\n}\n.row-calendar.row-left[data-v-49686237] {\n    width: 111px;\n}\n.row-calendar.row-left-footer[data-v-49686237] {\n      border-right: 2px solid #dadada;\n      background-color: #303645;\n      height: 18.5px;\n      width: 112px;\n}\n.row-calendar.row-left-footer .text-footer[data-v-49686237] {\n        color: white;\n        font-family: \"San Francisco Display Bold\";\n}\n.row-calendar .text-footer[data-v-49686237] {\n    color: #828282;\n    font-size: 12px;\n    padding-left: 7px;\n    text-align: left;\n}\n.row-calendar.row-calendar-total-availability[data-v-49686237] {\n    height: auto;\n}\n.col-calendar[data-v-49686237] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.col-calendar-4[data-v-49686237] {\n    float: left;\n    height: auto;\n    width: 111px;\n}\n.col-calendar-31[data-v-49686237] {\n    -ms-flex-item-align: center;\n        align-self: center;\n    float: left;\n    height: auto;\n    overflow: auto;\n    position: relative;\n    width: calc(100% - 111px);\n}\n.col-calendar-1[data-v-49686237] {\n    width: calc(100% / 31);\n}\np[data-v-49686237] {\n  margin: 0px;\n}\n.tag[data-v-49686237] {\n  display: block;\n  height: 26.5px;\n  line-height: 26.5px;\n  margin: 0 !important;\n  padding: 0px;\n  position: absolute;\n  text-align: left;\n  -webkit-transform: skewX(-28deg);\n          transform: skewX(-28deg);\n  width: 106%;\n}\n.tag.z-index[data-v-49686237] {\n    z-index: 1;\n}\n.tag-init-day[data-v-49686237] {\n    left: auto;\n    padding-left: 5px;\n    right: -10px;\n    width: 54%;\n    z-index: 1;\n}\n.tag span.tag-name[data-v-49686237] {\n    color: white;\n    overflow: hidden;\n    position: absolute;\n    -webkit-transform: skewX(28deg);\n            transform: skewX(28deg);\n    white-space: nowrap;\n    width: -webkit-max-content;\n    width: -moz-max-content;\n    width: max-content;\n    z-index: 1;\n}\n.tag-end-day[data-v-49686237] {\n    left: -1px;\n    right: auto;\n    -webkit-transform: skewX(-28deg);\n            transform: skewX(-28deg);\n    width: 50%;\n}\n.tag-container[data-v-49686237] {\n    height: 27px;\n    margin-top: 5.5px;\n    position: relative;\n}\n.tag-information[data-v-49686237] {\n    background-color: rgba(255, 255, 255, 0.96);\n    border: 0.5px solid #a4a4a4;\n    border-radius: 10px;\n    -webkit-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);\n            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);\n    padding: 14px 18px;\n    position: absolute;\n    right: -120px;\n    top: 20px;\n    width: 219px;\n    z-index: 2;\n}\n.tag-information .title[data-v-49686237] {\n      color: #2e394b;\n      font-family: \"San Francisco Display Bold\";\n      font-size: 14px;\n      margin-bottom: 8px;\n      text-align: left;\n      text-transform: uppercase;\n}\n.tag-information .content-row[data-v-49686237] {\n      font-family: \"San Francisco Display Medium\";\n      font-size: 14px;\n      margin-top: 10px;\n      text-align: left;\n}\n.tag-information .content-row label[data-v-49686237] {\n        color: #29abe2;\n        font-family: \"San Francisco Display Bold\";\n}\n.tag-information .content-row span[data-v-49686237] {\n        color: #808080;\n}\n.tag-menu-modal[data-v-49686237] {\n    height: 100%;\n    width: 100%;\n}\n.tag-menu-title[data-v-49686237] {\n    color: #2e394b;\n    font-family: \"San Francisco Display Bold\";\n    font-size: 14px;\n}\n.tag-menu-body label[data-v-49686237] {\n    color: #29abe2;\n    font-family: \"San Francisco Display Bold\";\n    font-size: 14px;\n}\n.tag-menu-body span[data-v-49686237] {\n    color: #9b9b9b;\n    font-family: \"San Francisco Display\";\n    font-size: 14px;\n}\n.tag-menu-sidebar[data-v-49686237] {\n    border-bottom-left-radius: 10px;\n    border-bottom-right-radius: 10px;\n    height: 100%;\n}\n.tag-menu-sidebar .list__tile__title[data-v-49686237],\n    .tag-menu-sidebar .list__tile__action[data-v-49686237] {\n      color: #2f302f;\n      font-family: \"San Francisco Display\";\n      font-size: 12px;\n}\n.tag-menu-sidebar .list__tile__action[data-v-49686237] {\n      color: #8b9293;\n      padding-left: 16px;\n}\n.tag-menu-sidebar .list__tile__action i[data-v-49686237] {\n        font-size: 16px;\n}\n.tag-menu-sidebar li[data-v-49686237] {\n      border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n}\n.tag-menu-sidebar li[data-v-49686237]:last-child {\n        border-bottom: 0px;\n}\n.tag-menu-border[data-v-49686237] {\n    border-right: 1px solid rgba(0, 0, 0, 0.12);\n}\n.select[data-v-49686237] {\n  position: relative;\n  text-align: left;\n}\n.select select.select-roomtype[data-v-49686237] {\n    color: #8094a0;\n    font-size: 11px;\n    height: 27px;\n    outline: none;\n    position: relative;\n    width: 100%;\n}\n.header-booking-data[data-v-49686237] {\n  height: 31px;\n  position: absolute;\n  right: 20px;\n  text-align: right;\n  top: 52px;\n  width: calc(100% - 230px);\n}\n.header-booking-data-calendar[data-v-49686237] {\n    margin: 0px !important;\n    position: static;\n    width: 100%;\n}\n.header-booking-data div[data-v-49686237] {\n    padding-bottom: 0px !important;\n    padding-top: 0px !important;\n}\n.header-booking-data p[data-v-49686237] {\n    color: #2e394b;\n    font-family: \"San Francisco Display\";\n    font-size: 10px;\n    margin: 0px;\n    text-transform: uppercase;\n}\n.header-booking-data span[data-v-49686237] {\n    color: #29abe2;\n    font-family: \"San Francisco Display Medium\";\n    font-size: 15px;\n}\n.header-booking-data .border-select[data-v-49686237] {\n    border-right: 1px solid #979797;\n    margin-right: 16px;\n    padding-right: 16px !important;\n}\n.tasks-calendar-header[data-v-49686237] {\n  margin-bottom: 16px;\n}\n.tasks-calendar-header .title[data-v-49686237] {\n    color: #545e72;\n    font-family: \"San Francisco Display Medium\";\n    font-size: 11px !important;\n    text-align: left;\n}\n.tasks-calendar-header .period[data-v-49686237] {\n    text-align: right;\n}\n.tasks-calendar-header .period label[data-v-49686237] {\n      color: #828282;\n      font-family: \"San Francisco Display\";\n      font-size: 14px;\n      margin-left: 14px;\n}\n.tasks-calendar-header .period .active[data-v-49686237] {\n      border-bottom: 1px solid #545e72;\n      color: #545e72;\n      font-family: \"San Francisco Display Medium\";\n}\n.tasks-calendar-header .period .select[data-v-49686237] {\n      border-left: 1px solid #e2e2e2;\n      display: inline-block;\n      height: 13px;\n      line-height: 13px;\n      margin-left: 4px;\n      position: relative;\n      text-align: left;\n      width: 52px;\n}\n.tasks-calendar-header .period .select.select-calendar[data-v-49686237] {\n        width: auto;\n}\n.tasks-calendar-header .button-ranges[data-v-49686237] {\n    border-radius: 5px;\n    -webkit-box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.18);\n            box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.18);\n    color: #545e72;\n    outline: none;\n    padding: 0px 8px;\n}\n.assign-room[data-v-49686237] {\n  min-width: auto !important;\n}\n.size-btn[data-v-49686237] {\n  height: auto;\n  width: auto;\n}\n.mb-8[data-v-49686237] {\n  margin-bottom: 8px;\n}\n.border-right[data-v-49686237] {\n  border-right: 1px solid #d8d8d8;\n}\n.caption .color[data-v-49686237] {\n  border-radius: 3px;\n  display: inline-block;\n  height: 10px;\n  margin-right: 4px;\n  vertical-align: middle;\n  width: 10px;\n}\n.caption .color.check-in[data-v-49686237] {\n    background-color: #0fe270;\n}\n.caption .color.check-out[data-v-49686237] {\n    background-color: #ff0053;\n}\n.caption .color.taken[data-v-49686237] {\n    background-color: #00b5ef;\n}\n.caption .color.locked[data-v-49686237] {\n    background-color: #a5aeb0;\n}\n.caption .color.in-house[data-v-49686237] {\n    background-color: #353b51;\n}\n.caption .title[data-v-49686237] {\n  color: #545e72;\n  font-family: \"San Francisco Display\";\n  font-size: 14px;\n  vertical-align: middle;\n}\n.taken-bar[data-v-49686237] {\n  color: #c3c3c3;\n  font-family: \"San Francisco Display Medium\";\n  font-size: 11px;\n}\n.row-taken-bar[data-v-49686237] {\n  background-color: #eefffa;\n}\n.row-taken-bar .col-calendar[data-v-49686237] {\n    background-color: #eefffa;\n}\n.btn-cancel.grey[data-v-49686237] {\n  background-color: #9b9b9b !important;\n}\n.headline[data-v-49686237] {\n  border-bottom: 1px solid #e1e1e1;\n  color: #818181;\n  font-family: \"San Francisco Display\";\n  font-size: 14px !important;\n  text-transform: capitalize;\n}\n.headline-title[data-v-49686237] {\n    color: #353c4c;\n    font-size: 18px;\n    font-weight: normal;\n    margin: 0px;\n    text-transform: none;\n}\n.headline-label[data-v-49686237] {\n    color: #545e72;\n    font-family: \"San Francisco Display Medium\";\n}\n.bar-data[data-v-49686237] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  background-color: white;\n  -webkit-box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);\n          box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 48px;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n}\n.bar-data-item[data-v-49686237] {\n    border-right: 1px solid #e2e2e2;\n    -webkit-box-flex: 1;\n        -ms-flex: 1 auto;\n            flex: 1 auto;\n}\n.bar-data-item[data-v-49686237]:last-of-type {\n      border-right: 0px;\n}\n.bar-data-item.no-border[data-v-49686237] {\n      border-right: 0px;\n}\n.bar-data-item p[data-v-49686237] {\n      color: #545e72;\n      font-family: \"San Francisco Display Medium\";\n      font-size: 14px;\n      margin-bottom: 0px;\n}\n.bar-data-item p span[data-v-49686237] {\n        color: #818181;\n        font-family: \"San Francisco Display\";\n        font-size: 14px;\n}\n.bar-data .bar-icon[data-v-49686237] {\n    font-size: 20px;\n    -webkit-box-pack: start;\n        -ms-flex-pack: start;\n            justify-content: flex-start;\n    width: 20px;\n}\n.modal-label[data-v-49686237] {\n  color: #2f302f;\n  font-family: \"San Francisco Display Medium\";\n  font-size: 14px;\n}\n.modal-text[data-v-49686237] {\n  color: #2f302f;\n  font-family: \"San Francisco Display\";\n  font-size: 14px;\n}\n.date-bar-fixed[data-v-49686237] {\n  height: 27px;\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n  z-index: 4;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1429:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(772)(true);
// imports


// module
exports.push([module.i, ".general-avaliability[data-v-83a1514c]{display:-webkit-box;display:-ms-flexbox;display:flex;position:relative;width:100%}.col-calendar[data-v-83a1514c]{color:#00ca52;cursor:pointer;display:table-cell;vertical-align:middle}.col-calendar-1[data-v-83a1514c]{background-color:#303645;height:36px;min-width:43px;width:100%}.col-calendar-1[data-v-83a1514c]:hover{opacity:.7}.avaliability-date[data-v-83a1514c]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;height:100%;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin:0;width:100%}.highlight-date[data-v-83a1514c],.selected-date[data-v-83a1514c]{background-color:#fff}.border-radius-right[data-v-83a1514c]{border-radius:0 50% 50% 0}.border-radius-left[data-v-83a1514c]{border-radius:50% 0 0 50%}", "", {"version":3,"sources":["/opt/build/repo/src/clerkinn/calendar/subComponents/GeneralAvailability.vue"],"names":[],"mappings":"AACA,uCACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,kBAAmB,AACnB,UAAY,CACb,AACD,+BACE,cAAe,AACf,eAAgB,AAChB,mBAAoB,AACpB,qBAAuB,CACxB,AACD,iCACE,yBAA0B,AAC1B,YAAa,AACb,eAAgB,AAChB,UAAY,CACb,AACD,uCACE,UAAa,CACd,AACD,oCACE,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,YAAa,AACb,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,SAAU,AACV,UAAY,CACb,AAID,iEACE,qBAAwB,CACzB,AACD,sCACE,yBAA2B,CAC5B,AACD,qCACE,yBAA2B,CAC5B","file":"GeneralAvailability.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\n.general-avaliability[data-v-83a1514c] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n  width: 100%;\n}\n.col-calendar[data-v-83a1514c] {\n  color: #00ca52;\n  cursor: pointer;\n  display: table-cell;\n  vertical-align: middle;\n}\n.col-calendar-1[data-v-83a1514c] {\n  background-color: #303645;\n  height: 36px;\n  min-width: 43px;\n  width: 100%;\n}\n.col-calendar-1[data-v-83a1514c]:hover {\n  opacity: 0.7;\n}\n.avaliability-date[data-v-83a1514c] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 100%;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  margin: 0;\n  width: 100%;\n}\n.selected-date[data-v-83a1514c] {\n  background-color: white;\n}\n.highlight-date[data-v-83a1514c] {\n  background-color: white;\n}\n.border-radius-right[data-v-83a1514c] {\n  border-radius: 0 50% 50% 0;\n}\n.border-radius-left[data-v-83a1514c] {\n  border-radius: 50% 0 0 50%;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1448:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1363);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(773)("f1ea9718", content, true);

/***/ }),

/***/ 1483:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1398);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(773)("4cbd58d2", content, true);

/***/ }),

/***/ 1514:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1429);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(773)("26e2a52a", content, true);

/***/ }),

/***/ 1545:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1514)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1263),
  /* template */
  __webpack_require__(1679),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-83a1514c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1546:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1448)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1264),
  /* template */
  __webpack_require__(1570),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-02ac0c9e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1570:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "avaliability-modal"
    }
  }, [(_vm.isLoading) ? _c('img', {
    attrs: {
      "src": _vm.controlinnLogo
    }
  }) : _c('div', {
    staticClass: "modal-header-date"
  }, [_c('span', [_vm._v(_vm._s(_vm.initDate))]), _vm._v(" "), _c('span', {
    staticClass: "total-nights"
  }, [_vm._v(_vm._s(_vm.totalNights) + " Noches")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.endDate))])]), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "rooms-quantity"
  }, [_c('p', [_vm._v("# Reservas")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('input-text', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.roomQuantity),
      callback: function($$v) {
        _vm.roomQuantity = _vm._n($$v)
      },
      expression: "roomQuantity"
    }
  })], 1)], 1), _vm._v(" "), _vm._l((_vm.roomsType), function(room, indexRoom) {
    return _c('div', {
      key: indexRoom,
      staticClass: "type-room"
    }, [_c('p', {
      staticClass: "room"
    }, [_vm._v(_vm._s(room.name))]), _vm._v(" "), _c('p', {
      staticClass: "avaliability"
    }, [_vm._v(_vm._s(room.total))]), _vm._v(" "), _c('v-flex', {
      staticClass: "reservation-btn xs4"
    }, [_c('v-btn', {
      staticClass: "btn-save",
      attrs: {
        "disabled": !_vm.avaliabilityCero
      },
      on: {
        "click": function($event) {
          _vm.goToReserve(_vm.initDate, _vm.endDate, _vm.subsidiary, room, _vm.roomQuantity)
        }
      }
    }, [_vm._v("\n\t\t\t\t\tReservar\n\t\t\t\t")])], 1)], 1)
  })], 2) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 1631:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    staticClass: "header-booking-data",
    attrs: {
      "wrap": "",
      "justify-end": "",
      "align-center": ""
    }
  }, [_c('amounts-component', {
    attrs: {
      "subsidiary-id": _vm.subsidiary
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "hide-details": "",
      "items": _vm.subsidiaries,
      "item-text": "name",
      "item-value": "id",
      "single-line": ""
    },
    on: {
      "input": _vm.loadTypeRooms,
      "change": _vm.onChangeSubsidiary
    },
    model: {
      value: (_vm.subsidiary),
      callback: function($$v) {
        _vm.subsidiary = $$v
      },
      expression: "subsidiary"
    }
  })], 1)], 1), _vm._v(" "), (_vm.bookingCode && _vm.bookingSelected && _vm.bookingSelected.summary &&
    _vm.bookingSelected.summary.personalInformation) ? _c('v-layout', {
    staticClass: "header-booking-data header-booking-data-calendar",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs8": "",
      "pr-3": ""
    }
  }, [_c('p', [_vm._v("Cliente")]), _vm._v(" "), _c('span', [_vm._v("\n\t\t\t\t" + _vm._s(_vm.bookingSelected.summary.personalInformation.name) + "\n\t\t\t\t" + _vm._s(_vm.bookingSelected.summary.personalInformation.lastName) + "\n\t\t\t")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": ""
    }
  }, [_c('p', [_vm._v("Cod. Reserva")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.bookingCode))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": "",
      "pr-3": ""
    }
  }, [_c('p', [_vm._v("Habitación")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.bookingSelected.summary.personalInformation.roomTypeCode) + " " + _vm._s(_vm.roomList.codeRoom))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "pr-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select filter-header-calendar",
    attrs: {
      "items": _vm.roomsList,
      "label": "Nº",
      "item-text": "codeRoom",
      "disabled": _vm.roomsList.length === 0,
      "hide-details": "",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.roomList),
      callback: function($$v) {
        _vm.roomList = $$v
      },
      expression: "roomList"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-btn', {
    staticClass: "assign-room",
    attrs: {
      "type": "button",
      "disabled": !_vm.roomList
    },
    on: {
      "click": _vm.assignBooking
    }
  }, [_vm._v("\n\t\t\t\t\t\tAsignar\n\t\t\t\t\t")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container-calendar mt-3"
  }, [_c('div', {
    staticClass: "tasks-calendar-header"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "pr-2": ""
    }
  }, [_c('v-layout', {
    staticClass: "calendar-range",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "border-right",
    attrs: {
      "md6": "",
      "pa-0": ""
    }
  }, [_c('v-menu', {
    staticClass: "menu-date-picker",
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 40,
      "max-width": "290px"
    },
    on: {
      "input": _vm.changeIcon
    },
    model: {
      value: (_vm.menuStart),
      callback: function($$v) {
        _vm.menuStart = $$v
      },
      expression: "menuStart"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Picker in menu",
      "prepend-icon": "event",
      "append-icon": _vm.arrowIconStart,
      "append-icon-cb": _vm.toggleIconStartDate,
      "single-line": "",
      "hide-details": "",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.dateStart),
      callback: function($$v) {
        _vm.dateStart = $$v
      },
      expression: "dateStart"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "es-PE",
      "date-format": _vm.changeFormatDate,
      "formatted-value": _vm.formatted,
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.dateStart),
      callback: function($$v) {
        _vm.dateStart = $$v
      },
      expression: "dateStart"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": "",
      "py-0": "",
      "pl-1": ""
    }
  }, [_c('v-menu', {
    staticClass: "menu-date-picker",
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "max-width": "290px"
    },
    on: {
      "input": _vm.changeEndIcon
    },
    model: {
      value: (_vm.menuEnd),
      callback: function($$v) {
        _vm.menuEnd = $$v
      },
      expression: "menuEnd"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Picker in menu",
      "append-icon": _vm.arrowIconEnd,
      "append-icon-cb": _vm.toggleIconEndDate,
      "single-line": "",
      "hide-details": "",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.dateEnd),
      callback: function($$v) {
        _vm.dateEnd = $$v
      },
      expression: "dateEnd"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "es-PE",
      "date-format": _vm.changeFormatDate,
      "formatted-value": _vm.formatted,
      "no-title": "",
      "scrollable": "",
      "allowed-dates": function (date) { return _vm.isAfterMethod(date, _vm.dateStart); }
    },
    on: {
      "input": _vm.showDates
    },
    model: {
      value: (_vm.dateEnd),
      callback: function($$v) {
        _vm.dateEnd = $$v
      },
      expression: "dateEnd"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-layout', {
    staticClass: "caption",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-start": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('span', {
    staticClass: "color check-in"
  }), _vm._v(" "), _c('label', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tCheck In\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('span', {
    staticClass: "color check-out"
  }), _vm._v(" "), _c('label', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tCheck Out\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('span', {
    staticClass: "color taken"
  }), _vm._v(" "), _c('label', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tReservada\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('span', {
    staticClass: "color locked"
  }), _vm._v(" "), _c('label', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tBloqueada\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('span', {
    staticClass: "color in-house"
  }), _vm._v(" "), _c('label', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tIn House\n\t\t\t\t\t\t\t")])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-layout', {
    staticClass: "container-actualizar",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "pr-3": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-action btn-darkblue white--text",
    attrs: {
      "small": ""
    },
    on: {
      "click": _vm.loadAvailability
    }
  }, [_c('v-icon', [_vm._v("autorenew")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('button-create', {
    attrs: {
      "text": "Crear reserva",
      "btn-function": true
    },
    on: {
      "function-click": _vm.goToBookingNew
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    ref: "base-calendar",
    staticClass: "base-calendar"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDateBarFixed),
      expression: "showDateBarFixed"
    }],
    ref: "bar-fixed",
    staticClass: "date-bar-fixed"
  }, [_c('div', {
    staticClass: "row-calendar row-days row-taken-bar"
  }, _vm._l((_vm.monthSelected.days), function(day) {
    return _c('div', {
      key: day.id,
      staticClass: "col-calendar col-calendar-1"
    }, [_c('p', [_vm._v(_vm._s(day.shortDay))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(day.day))])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "thead-calendar"
  }, [_c('div', {
    staticClass: "main-row"
  }, [_c('div', {
    ref: "col",
    staticClass: "col-calendar col-calendar-4"
  }, [_c('div', {
    staticClass: "row-calendar row-left row-taken-bar"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('v-select', {
    staticClass: "filter-select select-roomtype",
    attrs: {
      "label": "Tipo de Habitación",
      "hide-details": "",
      "item-text": "codeRoomtype",
      "item-value": "id",
      "single-line": "",
      "items": _vm.roomTypes
    },
    on: {
      "change": _vm.loadData
    },
    model: {
      value: (_vm.roomTypeSelected),
      callback: function($$v) {
        _vm.roomTypeSelected = $$v
      },
      expression: "roomTypeSelected"
    }
  })], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._l((_vm.rooms), function(room) {
    return _c('div', {
      key: room.id,
      staticClass: "row-calendar row-rooms row-left"
    }, [_c('p', {
      staticClass: "row-rooms-text"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(room.typeRoom.code) + " " + _vm._s(room.codeRoom) + "\n\t\t\t\t\t\t\t")])])
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)], 2), _vm._v(" "), _c('div', {
    ref: "col-calendar-31",
    staticClass: "col-calendar col-calendar-31"
  }, [_c('div', {
    ref: "movil-date",
    staticClass: "row-calendar row-days row-taken-bar",
    attrs: {
      "id": "movil-date"
    }
  }, _vm._l((_vm.monthSelected.days), function(day) {
    return _c('div', {
      key: day.id,
      staticClass: "col-calendar col-calendar-1"
    }, [_c('p', [_vm._v(_vm._s(day.shortDay))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(day.day))])])
  })), _vm._v(" "), _c('div', {
    staticClass: "row-calendar row-days row-taken-bar"
  }, _vm._l((_vm.roomsTaken), function(taken, takenIndex) {
    return _c('div', {
      key: takenIndex,
      staticClass: "col-calendar col-calendar-1 py-1"
    }, [_c('p', [_vm._v(_vm._s(taken.percent) + "%")])])
  })), _vm._v(" "), _vm._l((_vm.rooms), function(room) {
    return _c('div', {
      key: room.id,
      staticClass: "row-calendar row-calendar-body"
    }, _vm._l((_vm.monthSelected.days), function(day, dayIndex) {
      return _c('div', {
        key: day.id,
        staticClass: "col-calendar col-calendar-1",
        class: {
          'day-is-weekend': day.isWeekend,
            'day-is-selected': day.isSelected && room.isSelected,
            'day-is-taken': _vm.dayTaken(room, day)
        }
      }, [(_vm.dayTaken(room, day)) ? _c('div', {
        staticClass: "tag-container",
        attrs: {
          "draggable": "true",
          "droppable": "true"
        },
        on: {
          "dragover": function($event) {
            $event.preventDefault();
          },
          "drag": function($event) {
            _vm.dragEvent(room, day)
          },
          "drop": function($event) {
            _vm.dropEvent(room, day, $event)
          },
          "click": function($event) {
            $event.stopPropagation();
            _vm.newBooking($event, day, room)
          }
        }
      }, _vm._l((room.customers), function(customer, customerIndex) {
        return (_vm.validationTakenDay(customer, day)) ? _c('div', {
          key: customerIndex,
          staticClass: "tag",
          class: {
            'tag-init-day': customer.initDay === day.day,
              'tag-end-day': customer.endDay === day.day,
              'z-index': dayIndex === 0 && _vm.showName(dayIndex, customer, day.day)
          },
          style: (("background-color: " + (customer.color) + ";")),
          attrs: {
            "readonly": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.showCustomerInfo($event, room, customer, day)
            }
          }
        }, [(customer.initDay === day.day || _vm.showName(dayIndex, customer, day.day)) ? _c('span', {
          staticClass: "tag-name",
          style: (("max-width: calc((100% * " + (_vm.calculateLength(dayIndex, customer, day.day)) + ") - 18px)"))
        }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(customer.lastname) + " " + _vm._s(customer.name) + "\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()]) : _vm._e()
      })) : _vm._e(), _vm._v(" "), (_vm.newRanges.length !== 1 ||
        (_vm.newRanges[0] &&
          _vm.methodIsAfter(_vm.newRanges[0].day.date, day.date)) ||
        (_vm.newRanges[0] && (_vm.newRanges[0].room.id !== room.id)) ||
        (_vm.newRanges[0] &&
          _vm.methodIsSameDay(_vm.newRanges[0].day.date, day.date))) ? _c('div', {
        staticClass: "tag-container no-tag",
        attrs: {
          "draggable": "true",
          "droppable": "true"
        },
        on: {
          "dragover": function($event) {
            $event.preventDefault();
          },
          "drag": function($event) {
            _vm.dragEvent(room, day)
          },
          "drop": function($event) {
            _vm.dropEvent(room, day, $event)
          },
          "click": function($event) {
            $event.stopPropagation();
            _vm.newBooking($event, day, room)
          }
        }
      }) : _c('div', {
        staticClass: "tag-container no-tag",
        attrs: {
          "draggable": "true",
          "droppable": "true"
        },
        on: {
          "dragover": function($event) {
            $event.preventDefault();
          },
          "drag": function($event) {
            _vm.dragEvent(room, day)
          },
          "drop": function($event) {
            _vm.dropEvent(room, day, $event)
          },
          "click": function($event) {
            $event.stopPropagation();
            _vm.newBooking($event, day, room)
          }
        }
      })])
    }))
  }), _vm._v(" "), _c('div', {
    staticClass: "row-calendar row-calendar-footer"
  }, _vm._l((_vm.freeRooms), function(free, freeIndex) {
    return _c('div', {
      key: freeIndex,
      staticClass: "col-calendar col-calendar-1"
    }, [_c('p', {
      staticClass: "text-footer"
    }, [_vm._v(_vm._s(free.free))])])
  })), _vm._v(" "), _c('div', {
    staticClass: "row-calendar row-calendar-footer"
  }, _vm._l((_vm.freeRooms), function(free, freeIndex) {
    return _c('div', {
      key: freeIndex,
      staticClass: "col-calendar col-calendar-1"
    }, [_c('p', {
      staticClass: "text-footer"
    }, [_vm._v(_vm._s(free.currency) + _vm._s(_vm._f("round")(free.price)))])])
  })), _vm._v(" "), _c('div', {
    staticClass: "row-calendar row-calendar-footer row-calendar-total-availability"
  }, [_c('general-availability', {
    attrs: {
      "free-rooms": _vm.freeRooms,
      "subsidiary-id": _vm.subsidiary,
      "month-selected": _vm.monthSelected
    }
  })], 1)], 2)])])], 1)]), _vm._v(" "), _c('v-menu', {
    staticClass: "tag-menu-modal",
    attrs: {
      "content-class": "tag-menu-content",
      "min-width": "368",
      "nudge-top": 145,
      "nudge-left": 40,
      "position-absolutely": "",
      "position-x": _vm.xBooking,
      "position-y": _vm.yBooking,
      "z-index": "10"
    },
    model: {
      value: (_vm.menuBooking),
      callback: function($$v) {
        _vm.menuBooking = $$v
      },
      expression: "menuBooking"
    }
  }, [_c('v-list', {
    staticClass: "py-0 tag-menu-header"
  }, [_c('v-list-tile', [_c('v-list-tile-title', {
    staticClass: "tag-menu-title"
  }, [_vm._v("\n\t\t\t\t\tCheck in\n\t\t\t\t")]), _vm._v(" "), _c('v-list-tile-action', {
    staticClass: "justify-end"
  }, [_c('v-btn', {
    staticClass: "grey--text size-btn",
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.closeMenuBooking
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "tag-menu-border",
    attrs: {
      "xs7": ""
    }
  }, [_c('v-list', {
    staticClass: "tag-menu-body"
  }, [_c('v-list-tile', [_c('v-list-tile-title', [_c('label', [_vm._v("Booking ID:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.customerInfo.customer.numReservation))])])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-title', [_c('label', [_vm._v("Nombre:")]), _vm._v(" "), _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.customerInfo.customer.name) + "\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.customerInfo.customer.lastname) + "\n\t\t\t\t\t\t\t")])])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-title', [_c('label', [_vm._v("País:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.customerInfo.customer.country))])])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-title', [_c('label', [_vm._v("Check-in Date:")]), _vm._v(" "), _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("parseDate")(_vm.customerInfo.customer.dateRange[0])) + "\n\t\t\t\t\t\t\t")])])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-title', [_c('label', [_vm._v("Check-out date:")]), _vm._v(" "), _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("parseDate")(_vm.customerInfo.customer.dateRange[1])) + "\n\t\t\t\t\t\t\t")])])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-title', [_c('label', [_vm._v("Hora de salida:")]), _vm._v(" "), _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.getCheckoutHours(_vm.customerInfo.customer.dateRange[1])) + "\n\t\t\t\t\t\t\t")])])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-title', [_c('label', [_vm._v("Exonerado:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.customerInfo.exonerated))])])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-title', [_c('label', [_vm._v("Pago sin igv:")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm._f("round")(_vm.customerInfo.customer.total)))])])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-title', [_c('label', [_vm._v("Pago total:")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm._f("round")(_vm.customerInfo.customer.totalIgv)))])])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-title', [_c('label', [_vm._v("Consumo:")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm._f("round")(_vm.customerInfo.customer.subTotalConsumptions)))])])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-title', [_c('label', [_vm._v("Adultos:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.customerInfo.customer.adults))])])], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-title', [_c('label', [_vm._v("Niños:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.customerInfo.customer.childrens))])])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-list', {
    staticClass: "tag-menu-sidebar"
  }, [_c('v-list-tile', {
    on: {
      "click": _vm.seeBooking
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("remove_red_eye")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Visualizar")])], 1), _vm._v(" "), ((Number(_vm.customerInfo.customer.bookingState) === 4 &&
      !_vm.expiredReservation) ||
    (Number(_vm.customerInfo.customer.bookingState) === 1 &&
      !_vm.expiredReservation)) ? _c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.goToCheckIn(_vm.customerInfo.room.comSubsidiaryId,
          _vm.customerInfo.room.hotMsRoomtypeId)
      }
    }
  }, [_c('v-list-tile-action', [_c('img', {
    attrs: {
      "src": (_vm.$imageS3 + "/clerkinn/checkin-icon.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Check in")])], 1) : _vm._e(), _vm._v(" "), (_vm.validationCheckOut(_vm.customerInfo)) ? _c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.goToCheckOut(_vm.customerInfo.room.comSubsidiaryId,
          _vm.customerInfo.room.hotMsRoomtypeId)
      }
    }
  }, [_c('v-list-tile-action', [_c('img', {
    attrs: {
      "src": (_vm.$imageS3 + "/clerkinn/checkout-icon.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Check Out")])], 1) : _vm._e(), _vm._v(" "), (_vm.noShowOption(_vm.customerInfo)) ? _c('v-list-tile', {
    on: {
      "click": _vm.openNoShowBooking
    }
  }, [_c('v-list-tile-action', [_c('img', {
    attrs: {
      "src": (_vm.$imageS3 + "/clerkinn/no-show-icon.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-list-tile-title', [_vm._v("No show")])], 1) : _vm._e(), _vm._v(" "), (Number(_vm.customerInfo.customer.bookingState) === 1 ||
    Number(_vm.customerInfo.customer.bookingState) === 4) ? _c('v-list-tile', {
    on: {
      "click": _vm.openCancelBooking
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    staticClass: "red--text"
  }, [_vm._v("cancel")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Anular")])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": _vm.downloadCardTravel
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("print")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Tarjeta de Embarque")])], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.goToBilling(_vm.customerInfo.room.comSubsidiaryId,
          _vm.customerInfo.room.hotMsRoomtypeId)
      }
    }
  }, [_c('v-list-tile-action', [_c('img', {
    attrs: {
      "src": (_vm.$imageS3 + "/clerkinn/billing-icon.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Factura")])], 1), _vm._v(" "), (_vm.validationAdvancePayment(_vm.customerInfo)) ? _c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.goToPrepayment(_vm.customerInfo)
      }
    }
  }, [_c('v-list-tile-action', [_c('img', {
    attrs: {
      "src": (_vm.$imageS3 + "/clerkinn/pay-icon.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Adelanto")])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.goToDetailGuest(_vm.customerInfo.room.comSubsidiaryId,
          _vm.customerInfo.room.hotMsRoomtypeId)
      }
    }
  }, [_c('v-list-tile-action', [_c('img', {
    attrs: {
      "src": (_vm.$imageS3 + "/clerkinn/billing-icon.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Detalle de Huésped")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-menu', {
    staticClass: "tag-menu-modal new-booking",
    attrs: {
      "content-class": "tag-menu-content new-booking",
      "position-absolutely": "",
      "min-width": "148",
      "position-x": _vm.xNewBooking,
      "position-y": _vm.yNewBooking,
      "nudge-top": 36,
      "nudge-left": 20
    },
    model: {
      value: (_vm.menuNewBooking),
      callback: function($$v) {
        _vm.menuNewBooking = $$v
      },
      expression: "menuNewBooking"
    }
  }, [_c('v-list', {
    staticClass: "py-0 tag-menu-header"
  }, [_c('v-list-tile', [_c('v-list-tile-title', {
    staticClass: "tag-menu-title"
  }, [_vm._v("\n\t\t\t\t\tReserva\n\t\t\t\t")]), _vm._v(" "), _c('v-list-tile-action', {
    staticClass: "justify-end"
  }, [_c('v-btn', {
    staticClass: "grey--text size-btn",
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.closeMenuNew
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-list', {
    staticClass: "tag-menu-sidebar"
  }, [_c('v-list-tile', {
    on: {
      "click": _vm.goToReserve
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Agregar")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "480px"
    },
    model: {
      value: (_vm.modalCancelBooking),
      callback: function($$v) {
        _vm.modalCancelBooking = $$v
      },
      expression: "modalCancelBooking"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline py-2 px-5"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "text-xs-left": ""
    }
  }, [_c('p', {
    staticClass: "headline-title"
  }, [_vm._v("\n\t\t\t\t\t\t\tAnulación de reserva\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "text-xs-right": ""
    }
  }, [_c('label', {
    staticClass: "headline-label"
  }, [_vm._v("\n\t\t\t\t\t\t\tFecha:\n\t\t\t\t\t\t")]), _vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.today) + "\n\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "px-5"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('label', {
    staticClass: "label-title"
  }, [_vm._v("Motivo")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-border-inset",
    model: {
      value: (_vm.cancelModel.title),
      callback: function($$v) {
        _vm.cancelModel.title = $$v
      },
      expression: "cancelModel.title"
    }
  }), _vm._v(" "), (_vm.$v.cancelModel.title && _vm.$v.cancelModel.title.$invalid) ? _c('span', {
    staticClass: "caption red--text"
  }, [_vm._v("\n\t\t\t\t\t\t\tEl motivo de anulación es requerido\n\t\t\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mt-3": ""
    }
  }, [_c('label', {
    staticClass: "label-title"
  }, [_vm._v("Descripción")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-border-inset input-textarea input-note",
    attrs: {
      "no-resize": "",
      "multi-line": "",
      "rows": 3,
      "textarea": ""
    },
    model: {
      value: (_vm.cancelModel.description),
      callback: function($$v) {
        _vm.cancelModel.description = $$v
      },
      expression: "cancelModel.description"
    }
  }), _vm._v(" "), (_vm.$v.cancelModel.description && _vm.$v.cancelModel.description.$invalid) ? _c('span', {
    staticClass: "caption red--text"
  }, [_vm._v("\n\t\t\t\t\t\t\tLa descripción de la anulación es requerida\n\t\t\t\t\t\t")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "pr-2": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-cancel grey",
    nativeOn: {
      "click": function($event) {
        _vm.closeBookingModal('Cancel')
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tCancelar\n\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "pl-2": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-save",
    attrs: {
      "disabled": _vm.$v.$invalid
    },
    nativeOn: {
      "click": function($event) {
        _vm.cancelBooking($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tAceptar\n\t\t\t\t\t\t")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "380px"
    },
    model: {
      value: (_vm.modalNoShowBooking),
      callback: function($$v) {
        _vm.modalNoShowBooking = $$v
      },
      expression: "modalNoShowBooking"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline py-2 px-4"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-left": ""
    }
  }, [_c('p', {
    staticClass: "headline-title"
  }, [_vm._v("\n\t\t\t\t\t\t\tNo-show de reserva\n\t\t\t\t\t\t")])])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "px-4"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('label', {
    staticClass: "headline-label"
  }, [_vm._v("\n\t\t\t\t\t\t\tBooking ID:\n\t\t\t\t\t\t")]), _vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.noShowModel.codeBooking) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('label', {
    staticClass: "headline-label"
  }, [_vm._v("\n\t\t\t\t\t\t\tNombre:\n\t\t\t\t\t\t")]), _vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.customerInfo.customer.name) + "\n\t\t\t\t\t\t" + _vm._s(_vm.customerInfo.customer.lastname) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "mt-2": ""
    }
  }, [_c('label', {
    staticClass: "label-title"
  }, [_vm._v("No-show")]), _vm._v(" "), _c('v-menu', {
    staticClass: "menu-date-picker mt-2",
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "max-width": "290px"
    },
    on: {
      "input": _vm.changeIconDate
    },
    model: {
      value: (_vm.noShowDate),
      callback: function($$v) {
        _vm.noShowDate = $$v
      },
      expression: "noShowDate"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Fecha de nacimiento",
      "prepend-icon": "event",
      "append-icon": _vm.arrowIcon,
      "single-line": "",
      "hide-details": "",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.noShowModel.date),
      callback: function($$v) {
        _vm.noShowModel.date = $$v
      },
      expression: "noShowModel.date"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "es-PE",
      "year-icon": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.noShowModel.date),
      callback: function($$v) {
        _vm.noShowModel.date = $$v
      },
      expression: "noShowModel.date"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mt-3": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "input-checkbox input-booking",
    attrs: {
      "label": "Facturar",
      "color": "info",
      "hide-details": ""
    },
    model: {
      value: (_vm.noShowModel.flagBilling),
      callback: function($$v) {
        _vm.noShowModel.flagBilling = $$v
      },
      expression: "noShowModel.flagBilling"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "pr-2": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-cancel grey",
    nativeOn: {
      "click": function($event) {
        _vm.closeBookingModal('NoShow')
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tCancelar\n\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "pl-2": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-save",
    nativeOn: {
      "click": function($event) {
        _vm.noShowBooking($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tAceptar\n\t\t\t\t\t\t")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "783px"
    },
    model: {
      value: (_vm.modalSeeBooking),
      callback: function($$v) {
        _vm.modalSeeBooking = $$v
      },
      expression: "modalSeeBooking"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline py-2 pl-5"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "text-xs-left": ""
    }
  }, [_c('p', {
    staticClass: "headline-title"
  }, [_vm._v("\n\t\t\t\t\t\t\tVisualizar reserva\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "text-xs-right": "",
      "pl-0": ""
    }
  }, [_c('label', {
    staticClass: "headline-label"
  }, [_vm._v("\n\t\t\t\t\t\t\tBooking ID:\n\t\t\t\t\t\t")]), _vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.seeModel.numReservation) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "text-xs-right": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "grey",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.closeBookingModal('See')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "px-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "px-2": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "bar-data"
  }, [_c('div', {
    staticClass: "bar-data-item"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\tFecha de reserva:\n\t\t\t\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm._f("parseDate")(_vm.seeModel.bookingDate)))])])]), _vm._v(" "), _c('div', {
    staticClass: "bar-data-item"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\tLlegada:\n\t\t\t\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm._f("parseDate")(_vm.seeModel.bookingStart)))])])]), _vm._v(" "), _c('div', {
    staticClass: "bar-data-item"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\tSalida:\n\t\t\t\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm._f("parseDate")(_vm.seeModel.bookingEnd)))])])]), _vm._v(" "), _c('div', {
    staticClass: "bar-data-item"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\tNoches:\n\t\t\t\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm.seeModel.numberNights))])])]), _vm._v(" "), _c('div', {
    staticClass: "bar-data-item no-border"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\t\tHuésped:\n\t\t\t\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm.seeModel.quantity))])])])])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "px-4": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": "",
      "ml-1": ""
    }
  }, [_c('v-btn', {
    staticClass: "blue--text",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.goToCheckIn(_vm.customerInfo.room.comSubsidiaryId,
          _vm.customerInfo.room.hotMsRoomtypeId)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tEditar Clientes\n\t\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mb-2": "",
      "text-xs-left": "",
      "px-5": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('label', {
    staticClass: "modal-label"
  }, [_vm._v("\n\t\t\t\t\t\t\tNº Tarjeta\n\t\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "modal-text mt-2"
  }, [_vm._v(_vm._s(_vm.seeModel.customer.data.cardVip))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('label', {
    staticClass: "modal-label"
  }, [_vm._v("\n\t\t\t\t\t\t\tTipo de identificación\n\t\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "modal-text mt-2"
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.seeModel.customer.data.documentName) + ":\n\t\t\t\t\t\t\t" + _vm._s(_vm.seeModel.customer.data.numDocument) + "\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('label', {
    staticClass: "modal-label"
  }, [_vm._v("\n\t\t\t\t\t\t\tApellidos y Nombres\n\t\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "modal-text mt-2"
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.seeModel.customer.data.lastname) + ",\n\t\t\t\t\t\t\t" + _vm._s(_vm.seeModel.customer.data.name) + "\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('label', {
    staticClass: "modal-label"
  }, [_vm._v("\n\t\t\t\t\t\t\tCorreo electrónico\n\t\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "modal-text mt-2"
  }, [_vm._v(_vm._s(_vm.seeModel.customer.data.email))])])], 1), _vm._v(" "), (_vm.seeModel.customerAditional) ? _c('v-layout', {
    attrs: {
      "wrap": "",
      "pl-5": "",
      "mb-1": ""
    }
  }, [_c('label', [_vm._v("Huéspedes adicionales:")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.seeModel.customerAditional), function(customerAditional) {
    return _c('v-layout', {
      key: customerAditional.id,
      attrs: {
        "row": "",
        "wrap": "",
        "mb-4": "",
        "text-xs-left": "",
        "px-5": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('label', {
      staticClass: "modal-label"
    }, [_vm._v("\n\t\t\t\t\t\t\tTipo de identificación\n\t\t\t\t\t\t")]), _vm._v(" "), _c('p', {
      staticClass: "modal-text mt-2"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(customerAditional.documentName) + ":\n\t\t\t\t\t\t\t" + _vm._s(customerAditional.numDocument) + "\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('label', {
      staticClass: "modal-label"
    }, [_vm._v("\n\t\t\t\t\t\t\tApellidos y Nombres\n\t\t\t\t\t\t")]), _vm._v(" "), _c('p', {
      staticClass: "modal-text mt-2"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(customerAditional.lastname) + ",\n\t\t\t\t\t\t\t" + _vm._s(customerAditional.name) + "\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('p', {
      staticClass: "modal-text mt-4"
    }, [_vm._v(_vm._s(customerAditional.flagPerson))])])], 1)
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-divider')], 1)], 1), _vm._v(" "), (_vm.seeModel.channel) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "my-4": "",
      "text-xs-left": "",
      "px-5": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "mb-3": ""
    }
  }, [_c('label', {
    staticClass: "modal-label pr-2"
  }, [_vm._v("Segmento:")]), _vm._v(" "), _c('span', {
    staticClass: "modal-text"
  }, [_vm._v(_vm._s(_vm.seeModel.channel.data.name))])]), _vm._v(" "), _vm._l((_vm.seeModel.channel.data.questions), function(value, key) {
    return _c('v-flex', {
      key: key,
      attrs: {
        "xs2": "",
        "mr-3": ""
      }
    }, [_c('label', {
      staticClass: "modal-label"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(key) + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('p', {
      staticClass: "modal-text mt-2"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(value) + "\n\t\t\t\t\t\t")])])
  })], 2) : _vm._e()], 2), _vm._v(" "), _c('v-card-actions', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": "",
      "pr-2": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-cancel grey",
    nativeOn: {
      "click": function($event) {
        _vm.closeBookingModal('See')
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tCerrar\n\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "pl-2": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-success white--text",
    attrs: {
      "disabled": _vm.expiredReservation
    },
    nativeOn: {
      "click": function($event) {
        _vm.goToUpdateBooking($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tEditar\n\t\t\t\t\t\t")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row-calendar row-left row-taken-bar"
  }, [_c('span', {
    staticClass: "taken-bar"
  }, [_vm._v("Ocupación")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row-calendar row-left row-left-footer"
  }, [_c('p', {
    staticClass: "text-footer"
  }, [_vm._v("Disponible:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row-calendar row-left row-left-footer"
  }, [_c('p', {
    staticClass: "text-footer"
  }, [_vm._v("Tarifa:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row-calendar row-left row-left-footer"
  }, [_c('p', {
    staticClass: "text-footer text-xs-center px-0"
  }, [_vm._v("Diponibilidad")]), _vm._v(" "), _c('p', {
    staticClass: "text-footer text-xs-center px-0"
  }, [_vm._v("General")])])
}]}

/***/ }),

/***/ 1679:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "general-avaliability"
  }, [_vm._l((_vm.freeRooms), function(room, indexDay) {
    return _c('div', {
      key: indexDay,
      class: [
        'col-calendar',
        'col-calendar-1',
        _vm.ceroValue(room.free) ? 'red-value' : null ],
      on: {
        "click": function($event) {
          _vm.selectedDate(indexDay, _vm.flagActiveDate)
        }
      }
    }, [_c('p', {
      class: [
        'avaliability-date',
        _vm.firstDateSelected(indexDay) ? 'highlight-date' : null,
        _vm.rangeSelected(indexDay, _vm.rangeDate) ? 'highlight-date' : null,
        _vm.initRangeDate(indexDay, _vm.rangeDate) ? 'border-radius-left' : null,
        _vm.endRangeDate(indexDay, _vm.rangeDate) ? 'border-radius-right' : null ]
    }, [_vm._v("\n\t\t\t" + _vm._s(room.availabilities) + "\n\t\t")])])
  }), _vm._v(" "), (_vm.showAvaliabilityModal) ? _c('avaliability-modal', {
    attrs: {
      "calculate-position": _vm.rangeDate[0],
      "rooms-type": _vm.typesRooms,
      "init-date": _vm.initDate,
      "end-date": _vm.endDate,
      "total-nights": _vm.totalNights,
      "is-loading": _vm.isLoading,
      "subsidiary": _vm.subsidiaryId
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),

/***/ 800:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1483)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1259),
  /* template */
  __webpack_require__(1631),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-49686237",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 865:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.regex = exports.ref = exports.len = exports.req = exports.withParams = undefined;

var _withParams = __webpack_require__(903);

var _withParams2 = _interopRequireDefault(_withParams);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.withParams = _withParams2.default;

// "required" core, used in almost every validator to allow empty values

var req = exports.req = function req(value) {
  if (Array.isArray(value)) return !!value.length;
  if (value === undefined || value === null || value === false) {
    return false;
  }

  if (value instanceof Date) {
    // invalid date won't pass
    return !isNaN(value.getTime());
  }

  if (typeof value === 'object') {
    for (var _ in value) {
      return true;
    }return false;
  }

  return !!String(value).length;
};

// get length in type-agnostic way
var len = exports.len = function len(value) {
  if (Array.isArray(value)) return value.length;
  if (typeof value === 'object') {
    return Object.keys(value).length;
  }
  return String(value).length;
};

// resolve referenced value
var ref = exports.ref = function ref(reference, vm, parentVm) {
  return typeof reference === 'function' ? reference.call(vm, parentVm) : parentVm[reference];
};

// regex based validator template
var regex = exports.regex = function regex(type, expr) {
  return (0, _withParams2.default)({ type: type }, function (value) {
    return !req(value) || expr.test(value);
  });
};

/***/ }),

/***/ 871:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(881);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),

/***/ 879:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.maxValue = exports.minValue = exports.and = exports.or = exports.url = exports.sameAs = exports.requiredUnless = exports.requiredIf = exports.required = exports.minLength = exports.maxLength = exports.macAddress = exports.ipAddress = exports.email = exports.between = exports.numeric = exports.alphaNum = exports.alpha = undefined;

var _alpha = __webpack_require__(885);

var _alpha2 = _interopRequireDefault(_alpha);

var _alphaNum = __webpack_require__(886);

var _alphaNum2 = _interopRequireDefault(_alphaNum);

var _numeric = __webpack_require__(896);

var _numeric2 = _interopRequireDefault(_numeric);

var _between = __webpack_require__(888);

var _between2 = _interopRequireDefault(_between);

var _email = __webpack_require__(889);

var _email2 = _interopRequireDefault(_email);

var _ipAddress = __webpack_require__(890);

var _ipAddress2 = _interopRequireDefault(_ipAddress);

var _macAddress = __webpack_require__(891);

var _macAddress2 = _interopRequireDefault(_macAddress);

var _maxLength = __webpack_require__(892);

var _maxLength2 = _interopRequireDefault(_maxLength);

var _minLength = __webpack_require__(894);

var _minLength2 = _interopRequireDefault(_minLength);

var _required = __webpack_require__(898);

var _required2 = _interopRequireDefault(_required);

var _requiredIf = __webpack_require__(899);

var _requiredIf2 = _interopRequireDefault(_requiredIf);

var _requiredUnless = __webpack_require__(900);

var _requiredUnless2 = _interopRequireDefault(_requiredUnless);

var _sameAs = __webpack_require__(901);

var _sameAs2 = _interopRequireDefault(_sameAs);

var _url = __webpack_require__(902);

var _url2 = _interopRequireDefault(_url);

var _or = __webpack_require__(897);

var _or2 = _interopRequireDefault(_or);

var _and = __webpack_require__(887);

var _and2 = _interopRequireDefault(_and);

var _minValue = __webpack_require__(895);

var _minValue2 = _interopRequireDefault(_minValue);

var _maxValue = __webpack_require__(893);

var _maxValue2 = _interopRequireDefault(_maxValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.alpha = _alpha2.default;
exports.alphaNum = _alphaNum2.default;
exports.numeric = _numeric2.default;
exports.between = _between2.default;
exports.email = _email2.default;
exports.ipAddress = _ipAddress2.default;
exports.macAddress = _macAddress2.default;
exports.maxLength = _maxLength2.default;
exports.minLength = _minLength2.default;
exports.required = _required2.default;
exports.requiredIf = _requiredIf2.default;
exports.requiredUnless = _requiredUnless2.default;
exports.sameAs = _sameAs2.default;
exports.url = _url2.default;
exports.or = _or2.default;
exports.and = _and2.default;
exports.minValue = _minValue2.default;
exports.maxValue = _maxValue2.default;

/***/ }),

/***/ 881:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(882), __esModule: true };

/***/ }),

/***/ 882:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(273);
__webpack_require__(884);
module.exports = __webpack_require__(18).Array.from;


/***/ }),

/***/ 883:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(57);
var createDesc = __webpack_require__(142);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),

/***/ 884:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(61);
var $export = __webpack_require__(39);
var toObject = __webpack_require__(147);
var call = __webpack_require__(284);
var isArrayIter = __webpack_require__(283);
var toLength = __webpack_require__(149);
var createProperty = __webpack_require__(883);
var getIterFn = __webpack_require__(277);

$export($export.S + $export.F * !__webpack_require__(285)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),

/***/ 885:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(865);

exports.default = (0, _common.regex)('alpha', /^[a-zA-Z]*$/);

/***/ }),

/***/ 886:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(865);

exports.default = (0, _common.regex)('alphaNum', /^[a-zA-Z0-9]*$/);

/***/ }),

/***/ 887:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(865);

exports.default = function () {
  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({ type: 'and' }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid && fn.apply(_this, args);
    }, true);
  });
};

/***/ }),

/***/ 888:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(865);

exports.default = function (min, max) {
  return (0, _common.withParams)({ type: 'between', min: min, max: max }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +min <= +value && +max >= +value;
  });
};

/***/ }),

/***/ 889:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(865);

var emailRegex = /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/;

exports.default = (0, _common.regex)('email', emailRegex);

/***/ }),

/***/ 890:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(865);

exports.default = (0, _common.withParams)({ type: 'ipAddress' }, function (value) {
  if (!(0, _common.req)(value)) {
    return true;
  }

  if (typeof value !== 'string') {
    return false;
  }

  var nibbles = value.split('.');
  return nibbles.length === 4 && nibbles.every(nibbleValid);
});


var nibbleValid = function nibbleValid(nibble) {
  if (nibble.length > 3 || nibble.length === 0) {
    return false;
  }

  if (nibble[0] === '0' && nibble !== '0') {
    return false;
  }

  if (!nibble.match(/^\d+$/)) {
    return false;
  }

  var numeric = +nibble | 0;
  return numeric >= 0 && numeric <= 255;
};

/***/ }),

/***/ 891:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(865);

exports.default = function () {
  var separator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ':';
  return (0, _common.withParams)({ type: 'macAddress' }, function (value) {
    if (!(0, _common.req)(value)) {
      return true;
    }

    if (typeof value !== 'string') {
      return false;
    }

    var parts = typeof separator === 'string' && separator !== '' ? value.split(separator) : value.length === 12 || value.length === 16 ? value.match(/.{2}/g) : null;

    return parts !== null && (parts.length === 6 || parts.length === 8) && parts.every(hexValid);
  });
};

var hexValid = function hexValid(hex) {
  return hex.toLowerCase().match(/^[0-9a-f]{2}$/);
};

/***/ }),

/***/ 892:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(865);

exports.default = function (length) {
  return (0, _common.withParams)({ type: 'maxLength', max: length }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) <= length;
  });
};

/***/ }),

/***/ 893:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(865);

exports.default = function (max) {
  return (0, _common.withParams)({ type: 'maxValue', max: max }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value <= +max;
  });
};

/***/ }),

/***/ 894:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(865);

exports.default = function (length) {
  return (0, _common.withParams)({ type: 'minLength', min: length }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) >= length;
  });
};

/***/ }),

/***/ 895:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(865);

exports.default = function (min) {
  return (0, _common.withParams)({ type: 'minValue', min: min }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value >= +min;
  });
};

/***/ }),

/***/ 896:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(865);

exports.default = (0, _common.regex)('numeric', /^[0-9]*$/);

/***/ }),

/***/ 897:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(865);

exports.default = function () {
  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({ type: 'or' }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid || fn.apply(_this, args);
    }, false);
  });
};

/***/ }),

/***/ 898:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(865);

exports.default = (0, _common.withParams)({ type: 'required' }, _common.req);

/***/ }),

/***/ 899:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(865);

exports.default = function (prop) {
  return (0, _common.withParams)({ type: 'requiredIf', prop: prop }, function (value, parentVm) {
    return (0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

/***/ }),

/***/ 900:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(865);

exports.default = function (prop) {
  return (0, _common.withParams)({ type: 'requiredUnless', prop: prop }, function (value, parentVm) {
    return !(0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

/***/ }),

/***/ 901:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(865);

exports.default = function (equalTo) {
  return (0, _common.withParams)({ type: 'sameAs', eq: equalTo }, function (value, parentVm) {
    return value === (0, _common.ref)(equalTo, this, parentVm);
  });
};

/***/ }),

/***/ 902:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(865);

var urlRegex = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;

exports.default = (0, _common.regex)('url', urlRegex);

/***/ }),

/***/ 903:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/* istanbul ignore next */
var withParams =  false ? require('./withParamsBrowser').withParams : __webpack_require__(286).withParams;

exports.default = withParams;

/***/ }),

/***/ 921:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(925),
  /* template */
  __webpack_require__(945),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 925:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//


function sendValue(value) {
	this.$emit('input', value);
}

function sendValueOnBlur(value) {
	this.$emit('blur', value);
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'input-text',
	inheritAttrs: false,
	methods: {
		sendValue: sendValue,
		sendValueOnBlur: sendValueOnBlur
	},
	props: {
		labelText: {
			default: '',
			type: String
		},
		value: null
	}
});

/***/ }),

/***/ 945:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    staticClass: "label-form"
  }, [_vm._v(_vm._s(_vm.labelText))]), _vm._v(" "), _c('v-text-field', _vm._b({
    staticClass: "input-border-inset",
    attrs: {
      "value": _vm.value
    },
    on: {
      "input": _vm.sendValue,
      "blur": _vm.sendValueOnBlur
    }
  }, 'v-text-field', _vm.$attrs, false))], 1)
},staticRenderFns: []}

/***/ }),

/***/ 946:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_filters__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_mixins__ = __webpack_require__(56);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function subsidiaryId(id) {
	this.loadBookingsTotal(id);
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'amounts-component',
	filters: {
		round: __WEBPACK_IMPORTED_MODULE_0__shared_filters__["c" /* round */]
	},
	mixins: __WEBPACK_IMPORTED_MODULE_1__shared_mixins__["a" /* default */],
	props: {
		subsidiaryId: {
			required: true,
			type: [Number, String]
		}
	},
	watch: {
		subsidiaryId: subsidiaryId
	}
});

/***/ }),

/***/ 947:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(772)(true);
// imports


// module
exports.push([module.i, "p[data-v-5c70d746]{color:#2e394b;font-family:San Francisco Display;font-size:10px;margin:0;text-transform:uppercase}span[data-v-5c70d746]{color:#29abe2;font-family:San Francisco Display Medium;font-size:15px}.border-select[data-v-5c70d746]{border-right:1px solid #979797;padding-right:16px!important}", "", {"version":3,"sources":["/opt/build/repo/src/components/shared/AmountsComponent.vue"],"names":[],"mappings":"AACA,mBACE,cAAe,AACf,kCAAqC,AACrC,eAAgB,AAChB,SAAY,AACZ,wBAA0B,CAC3B,AACD,sBACE,cAAe,AACf,yCAA4C,AAC5C,cAAgB,CACjB,AACD,gCACE,+BAAgC,AAChC,4BAA+B,CAChC","file":"AmountsComponent.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\np[data-v-5c70d746] {\n  color: #2e394b;\n  font-family: \"San Francisco Display\";\n  font-size: 10px;\n  margin: 0px;\n  text-transform: uppercase;\n}\nspan[data-v-5c70d746] {\n  color: #29abe2;\n  font-family: \"San Francisco Display Medium\";\n  font-size: 15px;\n}\n.border-select[data-v-5c70d746] {\n  border-right: 1px solid #979797;\n  padding-right: 16px !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 948:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(947);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(773)("1474b784", content, true);

/***/ }),

/***/ 949:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(948)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(946),
  /* template */
  __webpack_require__(950),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5c70d746",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 950:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "border-select",
    attrs: {
      "xs4": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "align-center": "",
      "justify-end": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('p', [_vm._v("Ingresos")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm._f("round")(_vm.bookingsAmountTotal)))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('p', [_vm._v("Ocupación Actual")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.bookingsTotal))])])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 952:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(953), __esModule: true };

/***/ }),

/***/ 953:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(955);
module.exports = __webpack_require__(18).Object.keys;


/***/ }),

/***/ 954:
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(39);
var core = __webpack_require__(18);
var fails = __webpack_require__(90);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ 955:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(147);
var $keys = __webpack_require__(141);

__webpack_require__(954)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ })

});


// WEBPACK FOOTER //
// static/js/24.2d42958fe913cee8ad22.js